<template>
 <div>
  <el-dialog  :center="true" :close-on-click-modal="false" title="审批信息" :visible="showEdit" width="97%" @close="closeEditDialog" style="margin-left: 10%;">
    <el-form ref="order" :model="order" label-width="140px" :disabled="isDetail">
      
      <el-divider content-position="center"> 审批内容 </el-divider>

      <el-form-item label="学生类型">
        <el-select v-model="isClassType" style="width:100%;" placeholder="请选择学生类型" filterable :clearable="false" :disabled="typeCustomerFunding !== '定金'" >
          <el-option v-for="item in teacherss" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>


      <div v-if="typeCustomerFunding === '定金'">

        <el-form-item  v-if="isClassType == 1" label="付款金额：">
          <el-input :clearable="false" v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额"  :disabled="OrderStatus === 1"></el-input>
        </el-form-item>
        <el-form-item  v-if="isClassType == 1" label="收款时间：">
          <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间" :disabled="OrderStatus === 1"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isClassType == 1" label="收款渠道：">
          <el-select  filterable :clearable="false"  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道" :disabled="OrderStatus === 1">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isClassType == 1 || isProject == 1" label="诊断课：">
          <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入诊断课" :disabled="OrderStatus === 1"></el-input>
        </el-form-item>


        <el-form-item  v-if="isClassType == 3" label="付款金额：">
          <el-input :clearable="false" v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额" :disabled="OrderStatus === 1"></el-input>
        </el-form-item>
        <el-form-item  v-if="isClassType == 3" label="收款时间：">
          <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间" :disabled="OrderStatus === 1"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isClassType == 3" label="收款渠道：">
          <el-select  filterable :clearable="false"  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道" :disabled="OrderStatus === 1">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isClassType == 3" label="学业课：">
          <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入学业课" :disabled="OrderStatus === 1"></el-input>
        </el-form-item>


        <el-form-item  label="上传截图:">
            <div style="display: flex; padding-top: 5px;">
              <el-button size="small" type="primary" class="btns" @click="handleUpload('定金')">点击上传</el-button>
            </div>

            <div v-if="fileAllLists.length > 0">
               <div v-for="(itme,index) in fileAllLists" :key="index" style="margin-top: 10px;margin-left: 10px;">
                 <img style="width: 60%; height: 400px;" :src="itme.url" alt=""  v-if="itme.url">
               </div>
               <div style="width: 100%; text-align: center; margin-left: 120px;">
                <el-button size="small" type="danger" class="btns" @click="handleUploadDelet('1')">删除</el-button>
               </div>
            </div>
        </el-form-item>


      </div>


      <div v-if="typeCustomerFunding === '成单'">

  

        <el-form-item label="是否收费" v-if="costType === 1  || costType === 2">
          <el-select  v-model="isThereACharge" filterable  clearable style="width: 100%;" placeholder="请选择是否收费" @change="changeisThereACharge" size="small" :disabled="true">
            <el-option v-for="item in isThereAChargeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程类型" v-if="(costType === 1  || costType === 2) && isThereACharge === 1">
          <el-select  v-model="isTypeLve" filterable  clearable style="width: 100%;"   size="small" :disabled="true">
            <el-option v-for="item in payTypeLsit11" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item  v-if="costType === 1 && costType === 1">
          <div>
            <el-button  :disabled="true"  :type="setWay === '全款' ?'primary' : ''"  @click="handleSetWay('全款')">全款</el-button>
            <el-button  :disabled="true"  :type="setWay === '分期' ?'primary' : ''"  @click="handleSetWay('分期')">分期</el-button>
          </div>
       
        </el-form-item> 



        <div style="padding-left: 150px; display: flex; margin-top: 20px;margin-bottom: 20px;" v-if="costType === 2">
          <div style="padding-top: 7px;"><span style="padding-top: 7px;">合同金额：</span></div>
          <div>
            <el-input :clearable="false" v-model="contractAmount" autocomplete="off" size="small" placeholder="请输入合同金额" ></el-input>
          </div>
        </div>

        <!--  =================================================================( 全款 ) =========================================================-->

        <div style="display: flex; height: 650px; margin-bottom: 50px;" v-if="costType === 1">


          <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
            <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 成 单 收 费 </div>
          </div>

          <!-- 展示学业课table -->
          <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;" v-if="isTypeLve === 1">

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                <div style="width: 56%; padding-top: 70px; height: 160px; ">
                   <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder="请输入规划费"></el-input>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseMoney" autocomplete="off" size="small" placeholder="请输入诊断费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseHour" autocomplete="off" size="small" placeholder="请输入诊断课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseGiveHour" autocomplete="off" size="small" placeholder="请输入诊断课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业课费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor"  :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>
             
              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入学习力费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;"  class="inputcolor" :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入学习力课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder="请输入学习力课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentMoney" autocomplete="off" size="small" placeholder="请输入学生个案费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentHour" autocomplete="off" size="small" placeholder="请输入学生个案课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentGiveHour" autocomplete="off" size="small" placeholder="请输入学生个案课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchMoney" autocomplete="off" size="small" placeholder="请输入家长个案费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchHour" autocomplete="off" size="small" placeholder="请输入家长个案课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchGiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读课费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="请输入伴读课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder="请输入伴读课时(赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder="请输入远程路补费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairClass" autocomplete="off" size="small" placeholder="请输入远程路补课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="请输入远程路补课时(赠送)"></el-input>
                  </div>
                </div>
              </div>

            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择收款时间"></el-date-picker>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-select style="width: 25%; margin-left: 10px;"  filterable clearable v-model="Paymentchannel" size="small"  placeholder="请选择收款渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
              <div style="width: 2250px;padding: 15px 0px;display: flex;">
                <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('全款')">点击上传</el-button>
                    <!-- <img v-for="item in chargeCollectionPicture" :src="item.url" :alt="item.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                    <span v-if="chargeCollectionPicture.length > 0" @click="handleView(chargeCollectionPicture[0].url, chargeCollectionPicture[0].width, chargeCollectionPicture[0].height)" style="color: #0999e1;margin-left: 10px;">预览</span> -->
                 <div v-if="chargeCollectionPicture.length > 0" style="margin-top: -7px;display: flex;"> 
                      <div v-for="(item,index) in chargeCollectionPicture" :key="index" style="margin-top: 4px;">
                        <img  :src="item.url" :alt="item.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                        <span v-if="item" @click="handleView(item.url, item.width, item.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                      </div>
                 </div>
              </div>
            </div>


            <div style="width: 100%;height: 200px;"> 
               <div style="display: flex; ">
                <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                      <div style="width: 45%;">
                        <div class="init-b">
                          <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                            <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                            <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                            <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                            <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                          </div>
                        </div>
                      </div>
                      <div style="width: 45%;margin-left: 10px;">
                        <div>
                          <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                        </div>
                      </div>
                </div>
               </div>
               <div style="width: 97%; text-align: end; margin-top: -34px; ">
                  <el-button  size="small"  type="primary"  @click="handleViewSet('全款','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel, chargeCollectionPicture })" style="margin-left: 10px;">再次提交</el-button>
               </div> 
            </div>

          </div>


          <!-- 展示家庭教育课table -->
          <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;" v-if="isTypeLve === 2">

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemMoney" autocomplete="off" size="small" placeholder="请输入学业课费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor"  :clearable="false" v-model="familyProblemHour" autocomplete="off" size="small" placeholder="请输入学业课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemGiveHour" autocomplete="off" size="small" placeholder="请输入学业课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>
             
              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayMoney" autocomplete="off" size="small" placeholder="请输入学习力费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;"  class="inputcolor" :clearable="false" v-model="patriarchReplayHour" autocomplete="off" size="small" placeholder="请输入学习力课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayGiveHour" autocomplete="off" size="small" placeholder="请输入学习力课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayMoney" autocomplete="off" size="small" placeholder="请输入学生个案费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayGiveHour" autocomplete="off" size="small" placeholder="请输入学生个案课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveMoney" autocomplete="off" size="small" placeholder="请输入家长个案费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveGiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseMoney" autocomplete="off" size="small" placeholder="请输入伴读课费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseHour" autocomplete="off" size="small" placeholder="请输入伴读课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseGiveHour" autocomplete="off" size="small" placeholder="请输入伴读课时(赠送)"></el-input>
                  </div>
                </div>
              </div>



              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择收款时间"></el-date-picker>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-select style="width: 25%; margin-left: 10px;"  filterable clearable v-model="Paymentchannel" size="small"  placeholder="请选择收款渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
              <div style="width: 2250px;padding: 15px 0px;display: flex;">
                <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('全款')">点击上传</el-button>
                    <!-- <img v-for="item in chargeCollectionPicture" :src="item.url" :alt="item.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                    <span v-if="chargeCollectionPicture.length > 0" @click="handleView(chargeCollectionPicture[0].url, chargeCollectionPicture[0].width, chargeCollectionPicture[0].height)" style="color: #0999e1;margin-left: 10px;">预览</span> -->
                 <div v-if="chargeCollectionPicture.length > 0" style="margin-top: -7px;display: flex;"> 
                      <div v-for="(item,index) in chargeCollectionPicture" :key="index" style="margin-top: 4px;">
                        <img  :src="item.url" :alt="item.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                        <span v-if="item" @click="handleView(item.url, item.width, item.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                      </div>
                 </div>
              </div>
            </div>


            <div style="width: 100%;height: 200px;"> 
               <div style="display: flex; ">
                <div style="width: 129px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                      <div style="width: 45%;">
                        <div class="init-b">
                          <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                            <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                            <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                            <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                            <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                          </div>
                        </div>
                      </div>
                      <div style="width: 45%;margin-left: 10px;">
                        <div>
                          <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                        </div>
                      </div>
                </div>
               </div>
               <div style="width: 97%; text-align: end; margin-top: -34px; ">
                  <el-button  size="small"  type="primary"  @click="handleViewSet1('全款','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel, chargeCollectionPicture })" style="margin-left: 10px;">再次提交</el-button>
               </div> 
            </div>

          </div>
        </div>



        <!-- 是否收费表格展示  ========================================( 分期 ) ------====================================================== -->
     
      <div v-if="costType === 2 && isTypeLve === 1">

       <div v-for="(item, index) in renewalCollectionListWay" :key="index">  
          <div style="display: flex; height: 650px;margin-bottom: 50px;" >
              <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
              </div>

              <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                    <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                    <div style="width: 56%; padding-top: 70px; height: 160px; ">
                      <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.Plan" autocomplete="off" size="small" placeholder="请输入规划费"></el-input>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseMoney" autocomplete="off" size="small" placeholder="请输入诊断费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseHour" autocomplete="off" size="small" placeholder="请输入诊断课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseGiveHour" autocomplete="off" size="small" placeholder="请输入诊断课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业课费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>
                
                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入学习力费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入学习力课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder="请输入学习力课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentMoney" autocomplete="off" size="small" placeholder="请输入学生个案费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentHour" autocomplete="off" size="small" placeholder="请输入学生个案课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentGiveHour" autocomplete="off" size="small" placeholder="请输入学生个案课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchMoney" autocomplete="off" size="small" placeholder="请输入家长个案费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchHour" autocomplete="off" size="small" placeholder="请输入家长个案课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchGiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读课费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder="请输入伴读课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="请输入伴读课时(赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder="请输入远程路补费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairClass" autocomplete="off" size="small" placeholder="请输入远程路补课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="请输入远程路补课时(赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择收款时间"></el-date-picker>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-select style="width: 25%; margin-left: 10px;"  filterable clearable  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                      <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                  <div style="width: 2250px; padding: 15px 0px;display: flex;">
                    <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('分期',index,item.chargeCollectionPicture)">点击上传</el-button>
                    <div v-if="item.chargeCollectionPicture.length > 0" style="margin-top: -7px; display: flex;"> 
                        <div v-for="(itmes,indexs) in item.chargeCollectionPicture" :key="indexs" style="margin-top: 12px;">
                          <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                          <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        </div>
                    </div>
                  </div>
                </div>


                <div style="width: 100%;height: 200px;"> 
                  <div style="display: flex; ">
                    <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                          <div style="width: 45%;">
                            <div class="init-b">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                            </div>
                          </div>
                          <div style="width: 45%;margin-left: 10px;">
                            <div>
                              <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                            </div>
                          </div>
                    </div>
                  </div>
                  <div style="width: 97%; text-align: end; margin-top: -34px; ">
                      <el-button  size="small"  type="primary"  @click="handleViewSet('分期','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.chargeCollectionPicture })" style="margin-left: 10px;">再次提交</el-button>
                  </div> 
                </div>

              </div>

          </div>

        </div>
      
      
      </div>



      <!-- 展示家庭教育课table -->
      <div v-if="costType === 2 && isTypeLve === 2">

       <div v-for="(item, index) in renewalCollectionListWay" :key="index">  
          <div style="display: flex; height: 650px;margin-bottom: 50px;" >
              <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
              </div>

              <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>
                
                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveMoney" autocomplete="off" size="small" placeholder="请输入家长个案费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveGiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时 (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseMoney" autocomplete="off" size="small" placeholder="请输入伴读课费"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseHour" autocomplete="off" size="small" placeholder="请输入伴读课时"></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseGiveHour" autocomplete="off" size="small" placeholder="请输入伴读课时(赠送)"></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>

                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择收款时间"></el-date-picker>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-select style="width: 25%; margin-left: 10px;"  filterable clearable  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                      <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                  <div style="width: 2250px; padding: 15px 0px;display: flex;">
                    <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('分期',index,item.chargeCollectionPicture)">点击上传</el-button>
                    <div v-if="item.chargeCollectionPicture.length > 0" style="margin-top: -7px; display: flex;"> 
                        <div v-for="(itmes,indexs) in item.chargeCollectionPicture" :key="indexs" style="margin-top: 12px;">
                          <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                          <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        </div>
                    </div>
                  </div>
                </div>


                <div style="width: 100%;height: 200px;"> 
                  <div style="display: flex; ">
                    <div style="width: 129px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                          <div style="width: 45%;">
                            <div class="init-b">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                            </div>
                          </div>
                          <div style="width: 45%;margin-left: 10px;">
                            <div>
                              <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                            </div>
                          </div>
                    </div>
                  </div>
                  <div style="width: 97%; text-align: end; margin-top: -34px; ">
                      <el-button  size="small"  type="primary"  @click="handleViewSet1('分期','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.chargeCollectionPicture })" style="margin-left: 10px;">再次提交</el-button>
                  </div> 
                </div>

              </div>

          </div>

        </div>
      
      
      </div>
       


    
        <!-- ======================是否续费==============================（续费）==========================================================================收费 -->

        <el-form-item label="是否续费" v-if="costType === 3 ">
          <el-select  v-model="isYouWantToRenew" filterable clearable style="width: 100%;" placeholder="请选择是否续费" size="small">
            <el-option v-for="item in isYouWantToRenewList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程类型" v-if="costType === 3 && isYouWantToRenew === 1">
          <el-select  v-model="isTypeLves" filterable  clearable style="width: 100%;"   size="small" :disabled="true">
            <el-option v-for="item in payTypeLsit11" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <div v-if="costType === 3 && isTypeLves === 1">

          <div    v-for="(item, index) in renewalCollectionList" :key="index">  

              <div style="display: flex; height: 650px;margin-bottom: 50px;" >


                <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                  <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '续 费 第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
                </div>


                <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                      <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                      <div style="width: 56%; padding-top: 70px; height: 160px; ">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.Plan" autocomplete="off" size="small" placeholder="请输入规划费"></el-input>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseMoney" autocomplete="off" size="small" placeholder="请输入诊断费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseHour" autocomplete="off" size="small" placeholder="请输入诊断课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseGiveHour" autocomplete="off" size="small" placeholder="请输入诊断课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业课费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>
                  
                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入学习力费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入学习力课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder="请输入学习力课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentMoney" autocomplete="off" size="small" placeholder="请输入学生个案费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentHour" autocomplete="off" size="small" placeholder="请输入学生个案课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentGiveHour" autocomplete="off" size="small" placeholder="请输入学生个案课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchMoney" autocomplete="off" size="small" placeholder="请输入家长个案费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchHour" autocomplete="off" size="small" placeholder="请输入家长个案课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchGiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读课费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder="请输入伴读课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="请输入伴读课时(赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder="请输入远程路补费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairClass" autocomplete="off" size="small" placeholder="请输入远程路补课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="请输入远程路补课时(赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择收款时间"></el-date-picker>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-select style="width: 25%; margin-left: 10px;"  filterable clearable v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                        <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex;">
                      <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('续费',index,item.renewCollectionPicture)">点击上传</el-button>
                      <div v-if="item.renewCollectionPicture.length > 0" style="margin-top: -7px; display: flex;"> 
                           <div v-for="(itmes,indexs) in item.renewCollectionPicture" :key="indexs" style="margin-top: 12px;">
                              <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                              <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                            </div>
                      </div>
                    </div>
                  </div>

                  <div style="width: 100%;height: 200px;"> 
                    <div style="display: flex; ">
                      <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                            <div style="width: 45%;">
                              <div class="init-b">
                                <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                  <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                  <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                  <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                  <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                </div>
                              </div>
                            </div>
                            <div style="width: 45%;margin-left: 10px;">
                              <div>
                                <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                              </div>
                            </div>
                      </div>
                    </div>
                    <div style="width: 97%; text-align: end; margin-top: -34px; ">
                        <el-button  size="small"  type="primary"  @click="handleViewSet('续费','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.renewCollectionPicture })" style="margin-left: 10px;">再次提交</el-button>
                    </div> 
                  </div>



                </div>

              </div>

          </div>

        </div>


        <div v-if="costType === 3 && isTypeLves === 2">

          <div    v-for="(item, index) in renewalCollectionList" :key="index">  

              <div style="display: flex; height: 650px;margin-bottom: 50px;" >


                <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                  <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '续 费 第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
                </div>


                <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>
                  
                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseMoney" autocomplete="off" size="small" placeholder="请输入课费"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseGiveHour" autocomplete="off" size="small" placeholder="请输入课时(赠送)"></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>


                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 149px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择收款时间"></el-date-picker>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <div style="width: 149px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-select style="width: 25%; margin-left: 10px;"  filterable clearable v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                        <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <div style="width: 149px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex;">
                      <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('续费',index,item.renewCollectionPicture)">点击上传</el-button>
                      <div v-if="item.renewCollectionPicture.length > 0" style="margin-top: -7px; display: flex;"> 
                           <div v-for="(itmes,indexs) in item.renewCollectionPicture" :key="indexs" style="margin-top: 12px;">
                              <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                              <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                            </div>
                      </div>
                    </div>
                  </div>

                  <div style="width: 100%;height: 200px;"> 
                    <div style="display: flex; ">
                      <div style="width: 149px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                            <div style="width: 45%;">
                              <div class="init-b">
                                <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                  <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                  <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                  <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                  <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                </div>
                              </div>
                            </div>
                            <div style="width: 45%;margin-left: 10px;">
                              <div>
                                <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                              </div>
                            </div>
                      </div>
                    </div>
                    <div style="width: 97%; text-align: end; margin-top: -34px; ">
                        <el-button  size="small"  type="primary"  @click="handleViewSet1('续费','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.renewCollectionPicture })" style="margin-left: 10px;">再次提交</el-button>
                    </div> 
                  </div>



                </div>

              </div>

          </div>

        </div>




      </div>


      <div v-if="typeCustomerFunding === '退费'" >


        <el-form-item label="客资状态">
           <div>{{ isCustomerStatus === 1 ? '定金客资' : isCustomerStatus === 2 ? '成单客资' : '' }}</div>
        </el-form-item>


        <el-form-item label="课程类型">
          <el-select   v-model="isTypeLvess" filterable  :clearable="false" style="width: 100%;" placeholder="请选择课程类型"  size="small">
            <el-option v-for="item in payTypeLsit11" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <div style="display: flex; height: 650px; margin-bottom: 50px;" v-if="costType === 4 && isTypeLvess === 1">


          <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
            <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 退费信息 </div>
          </div>

          <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                <div style="width: 56%; padding-top: 70px; height: 160px; ">
                   <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder="请输入规划费"></el-input>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseMoney" autocomplete="off" size="small" placeholder="请输入诊断费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseHour" autocomplete="off" size="small" placeholder="请输入诊断课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseGiveHour" autocomplete="off" size="small" placeholder="请输入诊断课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业课费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>
             
              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入学习力费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入学习力课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor"  :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder="请输入学习力课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentMoney" autocomplete="off" size="small" placeholder="请输入学生个案费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentHour" autocomplete="off" size="small" placeholder="请输入学生个案课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentGiveHour" autocomplete="off" size="small" placeholder="请输入学生个案课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchMoney" autocomplete="off" size="small" placeholder="请输入家长个案费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor"  :clearable="false" v-model="patriarchHour" autocomplete="off" size="small" placeholder="请输入家长个案课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchGiveHour" autocomplete="off" size="small" placeholder="请输入家长个案课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读课费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="请输入伴读课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder="请输入伴读课时(赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder="请输入远程路补费"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairClass" autocomplete="off" size="small" placeholder="请输入远程路补课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="请输入远程路补课时(赠送)"></el-input>
                  </div>
                </div>
              </div>

            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费时间</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择退费时间"></el-date-picker>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费渠道</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-select style="width: 25%; margin-left: 10px;"  filterable clearable  v-model="Paymentchannel" size="small"  placeholder="请选择退费渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">付款截图</div>
              <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('退费')">点击上传</el-button>
                <div v-if="chargeCollectionPicture.length > 0"> 
                     <img   :src="chargeCollectionPicture[0].url" :alt="chargeCollectionPicture[0].name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                            <span v-if="chargeCollectionPicture.length > 0" @click="handleView(chargeCollectionPicture[0].url, chargeCollectionPicture[0].width, chargeCollectionPicture[0].height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                </div>
              </div>
            </div>

            <div style="width: 100%;height: 200px;display: flex; "> 
               <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">驳回原因</div>
               <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                    <div style="width: 45%;">
                      <div class="init-b">
                        <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                          <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                          <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                          <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                          <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                        </div>
                      </div>
                    </div>
                    <div style="width: 45%;margin-left: 10px;">
                      <div>
                        <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                      </div>
                    </div>
                    <div style="width: 84%; text-align: end;padding-top: 100px;margin-right: 30px; position: absolute; bottom: 150px;">
                      <el-button  size="small"  type="primary"  @click="handleViewSet('退费','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel , chargeCollectionPicture})" style="margin-left: 10px;">再次提交</el-button>
                    </div> 
               </div>
            </div>


          </div>
        </div>

        <div style="display: flex; height: 650px; margin-bottom: 50px;" v-if="costType === 4 && isTypeLvess === 2">


          <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
            <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 退费信息 </div>
          </div>

          <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>
             
              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor"  :clearable="false" v-model="patriarchReplayGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor"  :clearable="false" v-model="educationPerceiveHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveGiveHour" autocomplete="off" size="small" placeholder="请输入课时 (赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseMoney" autocomplete="off" size="small" placeholder="请输入费用"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseHour" autocomplete="off" size="small" placeholder="请输入课时"></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseGiveHour" autocomplete="off" size="small" placeholder="请输入课时(赠送)"></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>


            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费时间</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" clearable placeholder="选择退费时间"></el-date-picker>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费渠道</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-select style="width: 25%; margin-left: 10px;"  filterable clearable  v-model="Paymentchannel" size="small"  placeholder="请选择退费渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">付款截图</div>
              <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns" @click="handleUpload('退费')">点击上传</el-button>
                <div v-if="chargeCollectionPicture.length > 0"> 
                     <img   :src="chargeCollectionPicture[0].url" :alt="chargeCollectionPicture[0].name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                            <span v-if="chargeCollectionPicture.length > 0" @click="handleView(chargeCollectionPicture[0].url, chargeCollectionPicture[0].width, chargeCollectionPicture[0].height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                </div>
              </div>
            </div>

            <div style="width: 100%;height: 200px;display: flex; "> 
               <div style="width: 129px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">驳回原因</div>
               <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                    <div style="width: 45%;">
                      <div class="init-b">
                        <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                          <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                          <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                          <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                          <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                        </div>
                      </div>
                    </div>
                    <div style="width: 45%;margin-left: 10px;">
                      <div>
                        <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                      </div>
                    </div>
                    <div style="width: 84%; text-align: end;padding-top: 100px;margin-right: 30px; position: absolute; bottom: 150px;">
                      <el-button  size="small"  type="primary"  @click="handleViewSet1('退费','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel , chargeCollectionPicture})" style="margin-left: 10px;">再次提交</el-button>
                    </div> 
               </div>
            </div>


          </div>
        </div>

      </div>





    </el-form>


    <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
       <div style="text-align: end;">
         <el-button size="small" @click="closeEditDialog">取 消</el-button>
         <!-- <el-button size="small" type="primary" @click="saveEditForm"  v-if="!isDetail">确 定</el-button> -->
       </div>
    </div>

  </el-dialog>




  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="原因"  :visible="isOrderStatus" :before-close="closeisOrderStatus" width="50%">
          <el-input v-model="isOrderStatusTextarea"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="请输入原因"></el-input>
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="isOrderStatus = false, isOrderStatusTextarea = ''">取 消</el-button>
              <el-button size="small" type="primary" @click="isOrderStatus = false">确 定</el-button>
            </div>
          </div>
  </el-dialog>




  <Elupload
   v-if="isShowElupload"
   @handleEventElUpload="handleEventElUpload"
   @handleEventElUploadSubt="handleEventElUploadSubt"
   :Uploadtypes="Uploadtypes"
   :fileAllLists="fileAllLists"

   :chargeCollectionPicture="chargeCollectionPicture"
   :renewalCollectionListWay="renewalCollectionListWayIndexList"

   :isTpyeImg="isTpyeImg"
   :isTypeListRow="isTypeListRow"
   :isTypeListindex="isTypeListindex"

  ></Elupload>




  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false"   :visible="isImg" :before-close="closeisImg" width="60%">
          <!-- <img  :src="isImgs" :alt="isImgs" style="width: 100%; height: 550px; margin: 10px;" > -->
          <img  :src="isImgs" :alt="isImgs" :style="{ width: imgWidth ? imgWidth + 'px' : '100%', height: imgHeight ? imgHeight + 'px' : '550px', margin: '10px', }">
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="closeisImg">取 消</el-button>
            </div>
          </div>
  </el-dialog>

 </div>
</template>



<script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import Elupload from "./Elupload.vue";

  export default {
    components: {
      Elupload,
    },
    props: {
      typeCustomerFunding:{
        default: "",
        type: String,
      },
      isUrView:{
        default: "",
        type: String,
      },
    },
    data() {
      return{

        happyMoney: '',
        happyHour: '',
        happyGiveHour: '',
        parentAwarenessMoney: '',
        parentAwarenessHour: '',
        parentAwarenessGiveHour: '',
        familyProblemMoney: '',
        familyProblemHour: '',
        familyProblemGiveHour: '',
        patriarchReplayMoney: '',
        patriarchReplayHour: '',
        patriarchReplayGiveHour: '',
        childReplayMoney: '',
        childReplayHour: '',
        childReplayGiveHour: '',
        educationPerceiveMoney: '',
        educationPerceiveHour: '',
        educationPerceiveGiveHour: '',
        fenCaseMoney: '',
        fenCaseHour: '',
        fenCaseGiveHour: '',


        affinityBookMoney: '',
        affinityBookHour: '',
        affinityBookGiveHour: '',

        isTypeLve: 1,
        isTypeLves: 1,
        isTypeLvess: 1,
        payTypeLsit11: [{ id: 1, name: '学业课' }, { id: 2, name: '家庭教育课' }],

        imgWidth: '',
        imgHeight: '',
        periodsNumber: '',

        activeNames: ['1'],
        activeNamess: ['1'],

        isImg:false,
        isImgs:'',

        textareaJson: [],
        newTextareaJson: '',


        isShowElupload: false,
        renewalCollectionListWayIndexList: [],

        isCustomsDeclarationchengRemarks: '',

        isCustomerStatus: '',

        ObjRow: {},

        teacherss: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],


        optionOrderStatus: [{id:0,name:'待成单'},{id:1,name:'已成单'},{id:2,name:'未成单'},{id:3,name:'已退费'}],

        isOrderStatus: false,


        paymentAmount: '',
        paymentAmountTime: '',
        paymentAmountChannel: '',
        paymentAmountCourse: '',

        DiagnosticClass : '',
        DiagnosticClassFee  : '',
        DiagnosticClassFeeGift  : '',

        doubtContent:[],

        isClassType: '',


        optionsListt:[
          {dictValue:"北京", dictType:1 },
          {dictValue:"深圳", dictType:2 },
          {dictValue:"深圳", dictType:3 },
        ],

        optionsList:[],

        newaddress:'',
        detailedAddress:'',
        remarks:'',

        searchResults: [],

        contractAmount: '',

        OrderStatus: 0,

        chengRemarks:[],
        ApprovalPeople: 63,
        optionList2:[],
        chengRemarksssss: '',

        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
        checked: false,
        checked1: false,
        expireTimeOption: {
          disabledDate (date) {
            //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
            return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        // time: '6:00',//钟表时间
        categoryList: [], //课程集合
        orderType: [
          {
            value: 1,
            label: '已成单'
          }, {
            value: 2,
            label: '已关单'
          },
          {
            value: 3,
            label: '已退费'
          },
        ],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
        propsCategory: {
          label: "categoryName",
          children: "children",
          value: "id"
        },
        payTypes: [
          {
            value: 1,
            label: "现金"
          },
          {
            value: 2,
            label: "微信"
          },
          {
            value: 3,
            label: "支付宝"
          },
          {
            value: 4,
            label: "银行卡"
          },
          {
            value: 5,
            label: "公户"
          },
          {
            value: 6,
            label: "小鹅通"
          }
          ,{
            value: 7,
            label: "美团"
          }
           ,{
            value: 8,
            label: "公户（桑穆）"
          }
           ,{
            value: 9,
            label: "公户（博川）"
          },
          {
            value: 10,
            label: "公户（蒙正心理）"
          },
        ], // 收款渠道选项
        customer: {},

        regionName:1,

        customerId: '',
        order: {
          saleId: "", //销售id
          educationType: "", //授课方式
          classHour: "",
          familyHour: "",
          state:"",
          classType: '',
          isRenew: "2",//是否续费
          orderStatus: "",//成单状态
          remarks: "", //备注
          parentPhoneNumber: "", //家长电话
          offTeacher: "",
          OffTimeHour: "", //线下诊断时间小时
          startTimeDay: "", //诊断时间天数
          startTimeHour: "", //诊断时间小时段
          payAlltype: "",
          gradeList: [], //年级
          teacherId: "", //诊断老师id
          startTime: [], //授课时间
          payType: "", //全款付款方式
          type: "", //成交状态
          onTime: "",
          offTime: "",
          onEndTime: "", //线上结束时间
          offEndTime: "", //线下结束时间
          onlineStatus: "", //如果线上checked为true他就不为空
          offlineStatus: "", //如果线下checked为true他就不为空
          onlineTime: [], //线上诊断时间
          teacherIdOffline: "", //线下诊断教师
          teacherIdOfflineArr: [],
          teacherIdOnline: "", //线上诊断教师
          teacherIdOnlineArr: [],
          offlineTime: [], //线下诊断时间
          isDiagnosisAllPay: "", //是否交诊断费
          Lastselected: '',//取消
          diagnosisAllPayMoney: "", //诊断费用
          diagnosisTime: "", //诊断费用收款时间
          diagnosisPayType: "", //诊断费用付款方式
          allPayMoney: "", //全款费用
          payTime: "", //交全款时间
          isAllPay: "", //是否是全额尾款，分期尾款
          studentName: "", //学生姓名
          grade: [], //年级id
          sex: "", // 性别
          address: "", //家庭地址
          regionName:1,
          studentId: "", //学生ID
          courseCategoryIds: [], //课程id
          customerInformationId: "", //客资id
          renews: [
            {
              renewType: "",//续费方式
              renewTime: "",//续费时间
              renewMoney: "",//续费金额
              classHourRenew: "",
              familyHourRenew: "",
            }
          ],
          stages: [
            {
              stagesMoney: "", // 分期金额
              stagesDate: "", // 分期时间
              payType: "", // 收款渠道
              agingClassHour: "",
              agingFamilyHour: ""
            }
          ]
        },
        customerAccountName: "",
        classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
        showEdit: false,
        rules: {
            studentName: [
              {
                required: true,
                message: "请输入学生名称",
                trigger: "blur"
              }
            ],
            grade: [
              {
                required: true,
                message: "请选择年级",
                trigger: "change"
              }
            ],
            sex: [{ required: true, message: "请选择性别", trigger: "change" }],
            address: [
              {
                required: true,
                message: "请输入家庭住址",
                trigger: "blur"
              }
            ],
            parentPhoneNumber: [
              {
                required: true,
                message: "请输入家长电话",
                trigger: "blur"
              },
              { type: "number", message: "家长电话必须为数字值" }
            ],
            courseCategoryIds: [
              { required: true, message: "请选择课程类别", trigger: "change" }
            ],
            teacherId: [
              { required: true, message: "请选择授课教师", trigger: "change" }
            ],
            startTime: [
              { required: true, message: "请选择授课时间", trigger: "change" }
            ]
          },


          isOrderStatusTextarea:'',

          teachers: [
            {
              value: 1,
              label: "小单老师",
            },
            {
              value: 2,
              label: "大单老师",
            },
            {
              value: 3,
              label: "刘老师",
            },
            {
              value: 4,
              label: "杨老师",
            },
          ],


          isThereAChargeList: [{id:1,name:'是'},{id:2,name:'否'}],
          isThereACharge:'',
          isThereACharge1:'',


          renewalCollectionListWay:[],

          chargeCollectionPicture: [],

          costType:'',

          Plan:'',
          diagnoseMoney : '',
          diagnoseHour  : '',
          diagnoseGiveHour  : '',

          studentMoney: '',
          studentHour: '',
          studentGiveHour: '',

          patriarchMoney: '',
          patriarchHour: '',
          patriarchGiveHour: '',

          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          PaymentTime:'',
          Paymentchannel:'',
          RemoteRoadRepair:'',

          classGiveHour:'', 
          familyGiveHour:'',
          readingGiveHour:'',


          RemoteRoadRepairClass:'',
          RemoteRoadRepairGiveHour:'',



          isYouWantToRenewList: [{id:1,name:'是'},{id:2,name:'否'}],
          isYouWantToRenew:'',




          renewalCollectionList:[],


          isTypeListRow: [],

          isProject : 0,

          isThereARefundList: [{id:1,name:'是'},{id:2,name:'否'}],
          isThereARefundList1: [{id:1,name:'是'},{id:2,name:'否'}],

          isThereARefundListt: [{id:1,name:'是'},{id:0,name:'否'}],  

          isThereARefund:'',


          isWantToContinueTheClass:'',

          isCustomsDeclaration: 2,


          isDetail: false,

          classType:'',

          infoObj: {},


          fileAllLists: [],
          Uploadtypes: '',


          isTypeListRow: [],
          isTpyeImg: false,

          setWay: '全款',

          isTypeListindex: 0,

          customerIds:'',
          ids:'',

      }
    },


    mounted () {
      this.getGrade();
      this.getTeachers();
      this.getCategoryList();



      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
      })

      axios.get(`${apiBaseUrl}/orderCustomerAudit/findAuditList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
        this.optionList2 = res.data.data
      })



      // .clock-picker__input-container{
      //   background: #f3f3f3 !important;
      // }

      this.payTypes = JSON.parse(sessionStorage.getItem('payTypesList'))
      this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj'))

      // this.getData();

    },


    methods: {


      handleViewSet1(type, index, url, Remark, { PaymentTime, Paymentchannel, chargeCollectionPicture }){
        this.ObjRow.customerId = this.customerIds
        this.ObjRow.id = this.ids


        if(type != '退费'){
          if(PaymentTime && Paymentchannel && chargeCollectionPicture.length > 0){

        

            this.ObjRow.commitRemark = Remark
            this.ObjRow.chargeCollectionDate = PaymentTime ? PaymentTime  : ''

            if(type === '全款'){
              this.ObjRow.projectMoney = this.Plan
              this.ObjRow.diagnoseMoney = this.diagnoseMoney
              this.ObjRow.diagnoseHour = this.diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
              this.ObjRow.studentMoney = this.studentMoney
              this.ObjRow.studentHour = this.studentHour
              this.ObjRow.studentGiveHour = this.studentGiveHour
              this.ObjRow.patriarchMoney = this.patriarchMoney
              this.ObjRow.patriarchHour = this.patriarchHour
              this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
              this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
              this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
              this.ObjRow.chargeCollectionDate = this.PaymentTime ? this.PaymentTime  : ''
              this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''



              this.ObjRow.happyMoney = this.happyMoney ? this.happyMoney  : ''
              this.ObjRow.happyHour = this.happyHour ? this.happyHour  : ''
              this.ObjRow.happyGiveHour = this.happyGiveHour ? this.happyGiveHour  : ''
              this.ObjRow.parentAwarenessMoney = this.parentAwarenessMoney ? this.parentAwarenessMoney  : ''
              this.ObjRow.parentAwarenessHour = this.parentAwarenessHour ? this.parentAwarenessHour  : ''
              this.ObjRow.parentAwarenessGiveHour = this.parentAwarenessGiveHour ? this.parentAwarenessGiveHour  : ''
              this.ObjRow.familyProblemMoney = this.familyProblemMoney ? this.familyProblemMoney  : ''
              this.ObjRow.familyProblemHour = this.familyProblemHour ? this.familyProblemHour  : ''
              this.ObjRow.familyProblemGiveHour = this.familyProblemGiveHour ? this.familyProblemGiveHour  : ''
              this.ObjRow.patriarchReplayMoney = this.patriarchReplayMoney ? this.patriarchReplayMoney  : ''
              this.ObjRow.patriarchReplayHour = this.patriarchReplayHour ? this.patriarchReplayHour  : ''
              this.ObjRow.patriarchReplayGiveHour = this.patriarchReplayGiveHour ? this.patriarchReplayGiveHour  : ''
              this.ObjRow.childReplayMoney = this.childReplayMoney ? this.childReplayMoney  : ''
              this.ObjRow.childReplayHour = this.childReplayHour ? this.childReplayHour  : ''
              this.ObjRow.childReplayGiveHour = this.childReplayGiveHour ? this.childReplayGiveHour  : ''
              this.ObjRow.educationPerceiveMoney = this.educationPerceiveMoney ? this.educationPerceiveMoney  : ''
              this.ObjRow.educationPerceiveHour = this.educationPerceiveHour ? this.educationPerceiveHour  : ''
              this.ObjRow.educationPerceiveGiveHour = this.educationPerceiveGiveHour ? this.educationPerceiveGiveHour  : ''
              this.ObjRow.fenCaseMoney = this.fenCaseMoney ? this.fenCaseMoney  : ''
              this.ObjRow.fenCaseHour = this.fenCaseHour ? this.fenCaseHour  : ''
              this.ObjRow.fenCaseGiveHour = this.fenCaseGiveHour ? this.fenCaseGiveHour  : ''

              this.ObjRow.affinityBookMoney = this.affinityBookMoney ? this.affinityBookMoney  : ''
              this.ObjRow.affinityBookHour = this.affinityBookHour ? this.affinityBookHour  : ''
              this.ObjRow.affinityBookGiveHour = this.affinityBookGiveHour ? this.affinityBookGiveHour  : ''



            }
            if(type === '分期'){
              this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan 
              this.ObjRow.diagnoseMoney = this.renewalCollectionListWay[0].diagnoseMoney
              this.ObjRow.diagnoseHour = this.renewalCollectionListWay[0].diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.renewalCollectionListWay[0].diagnoseGiveHour
              this.ObjRow.studentMoney = this.renewalCollectionListWay[0].studentMoney
              this.ObjRow.studentHour = this.renewalCollectionListWay[0].studentHour
              this.ObjRow.studentGiveHour = this.renewalCollectionListWay[0].studentGiveHour
              this.ObjRow.patriarchMoney = this.renewalCollectionListWay[0].patriarchMoney
              this.ObjRow.patriarchHour = this.renewalCollectionListWay[0].patriarchHour
              this.ObjRow.patriarchGiveHour = this.renewalCollectionListWay[0].patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan ? this.renewalCollectionListWay[0].Plan  : ''
              this.ObjRow.allPayMoney = this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : ''
              this.ObjRow.classMoney = this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : ''
              this.ObjRow.classHour = this.renewalCollectionListWay[0].AcademicClasses ? this.renewalCollectionListWay[0].AcademicClasses  : ''
              this.ObjRow.familyHour = this.renewalCollectionListWay[0].FamilyEducationClass ? this.renewalCollectionListWay[0].FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.renewalCollectionListWay[0].FamilyEducationExpenses ? this.renewalCollectionListWay[0].FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.renewalCollectionListWay[0].AccompanyingReadingFee ? this.renewalCollectionListWay[0].AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.renewalCollectionListWay[0].AccompanyingReading ? this.renewalCollectionListWay[0].AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.renewalCollectionListWay[0].RemoteRoadRepair ? this.renewalCollectionListWay[0].RemoteRoadRepair  : ''
              this.ObjRow.chargeCollectionDate = this.renewalCollectionListWay[0].PaymentTime ? this.renewalCollectionListWay[0].PaymentTime  : ''
              this.ObjRow.payAlltype = this.renewalCollectionListWay[0].Paymentchannel ? this.renewalCollectionListWay[0].Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.renewalCollectionListWay[0].classGiveHour ? this.renewalCollectionListWay[0].classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.renewalCollectionListWay[0].familyGiveHour ? this.renewalCollectionListWay[0].familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.renewalCollectionListWay[0].readingGiveHour ? this.renewalCollectionListWay[0].readingGiveHour  : ''
              this.ObjRow.contractCost = this.contractAmount ? this.contractAmount  : ''



              this.ObjRow.happyMoney = this.renewalCollectionListWay[0].happyMoney ? this.renewalCollectionListWay[0].happyMoney  : ''
              this.ObjRow.happyHour = this.renewalCollectionListWay[0].happyHour ? this.renewalCollectionListWay[0].happyHour  : ''
              this.ObjRow.happyGiveHour = this.renewalCollectionListWay[0].happyGiveHour ? this.renewalCollectionListWay[0].happyGiveHour  : ''
              this.ObjRow.parentAwarenessMoney = this.renewalCollectionListWay[0].parentAwarenessMoney ? this.renewalCollectionListWay[0].parentAwarenessMoney  : ''
              this.ObjRow.parentAwarenessHour = this.renewalCollectionListWay[0].parentAwarenessHour ? this.renewalCollectionListWay[0].parentAwarenessHour  : ''
              this.ObjRow.parentAwarenessGiveHour = this.renewalCollectionListWay[0].parentAwarenessGiveHour ? this.renewalCollectionListWay[0].parentAwarenessGiveHour  : ''
              this.ObjRow.familyProblemMoney = this.renewalCollectionListWay[0].familyProblemMoney ? this.renewalCollectionListWay[0].familyProblemMoney  : ''
              this.ObjRow.familyProblemHour = this.renewalCollectionListWay[0].familyProblemHour ? this.renewalCollectionListWay[0].familyProblemHour  : ''
              this.ObjRow.familyProblemGiveHour = this.renewalCollectionListWay[0].familyProblemGiveHour ? this.renewalCollectionListWay[0].familyProblemGiveHour  : ''
              this.ObjRow.patriarchReplayMoney = this.renewalCollectionListWay[0].patriarchReplayMoney ? this.renewalCollectionListWay[0].patriarchReplayMoney  : ''
              this.ObjRow.patriarchReplayHour = this.renewalCollectionListWay[0].patriarchReplayHour ? this.renewalCollectionListWay[0].patriarchReplayHour  : ''
              this.ObjRow.patriarchReplayGiveHour = this.renewalCollectionListWay[0].patriarchReplayGiveHour ? this.renewalCollectionListWay[0].patriarchReplayGiveHour  : ''
              this.ObjRow.childReplayMoney = this.renewalCollectionListWay[0].childReplayMoney ? this.renewalCollectionListWay[0].childReplayMoney  : ''
              this.ObjRow.childReplayHour = this.renewalCollectionListWay[0].childReplayHour ? this.renewalCollectionListWay[0].childReplayHour  : ''
              this.ObjRow.childReplayGiveHour = this.renewalCollectionListWay[0].childReplayGiveHour ? this.renewalCollectionListWay[0].childReplayGiveHour  : ''
              this.ObjRow.educationPerceiveMoney = this.renewalCollectionListWay[0].educationPerceiveMoney ? this.renewalCollectionListWay[0].educationPerceiveMoney  : ''
              this.ObjRow.educationPerceiveHour = this.renewalCollectionListWay[0].educationPerceiveHour ? this.renewalCollectionListWay[0].educationPerceiveHour  : ''
              this.ObjRow.educationPerceiveGiveHour = this.renewalCollectionListWay[0].educationPerceiveGiveHour ? this.renewalCollectionListWay[0].educationPerceiveGiveHour  : ''
              this.ObjRow.fenCaseMoney = this.renewalCollectionListWay[0].fenCaseMoney ? this.renewalCollectionListWay[0].fenCaseMoney  : ''
              this.ObjRow.fenCaseHour = this.renewalCollectionListWay[0].fenCaseHour ? this.renewalCollectionListWay[0].fenCaseHour  : ''
              this.ObjRow.fenCaseGiveHour = this.renewalCollectionListWay[0].fenCaseGiveHour ? this.renewalCollectionListWay[0].fenCaseGiveHour  : ''

              this.ObjRow.affinityBookMoney = this.renewalCollectionListWay[0].affinityBookMoney ? this.renewalCollectionListWay[0].affinityBookMoney  : ''
              this.ObjRow.affinityBookHour = this.renewalCollectionListWay[0].affinityBookHour ? this.renewalCollectionListWay[0].affinityBookHour  : ''
              this.ObjRow.affinityBookGiveHour = this.renewalCollectionListWay[0].affinityBookGiveHour ? this.renewalCollectionListWay[0].affinityBookGiveHour  : ''

            }

            if(type === '续费'){
              this.ObjRow.projectMoney = this.renewalCollectionList[0].Plan ? this.renewalCollectionList[0].Plan  : ''
              this.ObjRow.diagnoseMoney = this.renewalCollectionList[0].diagnoseMoney ? this.renewalCollectionList[0].diagnoseMoney  : ''
              this.ObjRow.diagnoseHour = this.renewalCollectionList[0].diagnoseHour ? this.renewalCollectionList[0].diagnoseHour  : ''
              this.ObjRow.diagnoseGiveHour = this.renewalCollectionList[0].diagnoseGiveHour ? this.renewalCollectionList[0].diagnoseGiveHour  : ''
              this.ObjRow.studentMoney = this.renewalCollectionList[0].studentMoney ? this.renewalCollectionList[0].studentMoney  : ''
              this.ObjRow.studentHour = this.renewalCollectionList[0].studentHour ? this.renewalCollectionList[0].studentHour  : ''
              this.ObjRow.studentGiveHour = this.renewalCollectionList[0].studentGiveHour ? this.renewalCollectionList[0].studentGiveHour  : ''
              this.ObjRow.patriarchMoney = this.renewalCollectionList[0].patriarchMoney ? this.renewalCollectionList[0].patriarchMoney  : ''
              this.ObjRow.patriarchHour = this.renewalCollectionList[0].patriarchHour ? this.renewalCollectionList[0].patriarchHour  : ''
              this.ObjRow.patriarchGiveHour = this.renewalCollectionList[0].patriarchGiveHour ? this.renewalCollectionList[0].patriarchGiveHour  : ''
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.renewalCollectionList[0].Plan ? this.renewalCollectionList[0].Plan  : ''
              this.ObjRow.allPayMoney = this.renewalCollectionList[0].AcademicExpenses ? this.renewalCollectionList[0].AcademicExpenses  : ''
              this.ObjRow.classHour = this.renewalCollectionList[0].AcademicClasses ? this.renewalCollectionList[0].AcademicClasses  : ''
              this.ObjRow.familyHour = this.renewalCollectionList[0].FamilyEducationClass ? this.renewalCollectionList[0].FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.renewalCollectionList[0].FamilyEducationExpenses ? this.renewalCollectionList[0].FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.renewalCollectionList[0].AccompanyingReadingFee ? this.renewalCollectionList[0].AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.renewalCollectionList[0].AccompanyingReading ? this.renewalCollectionList[0].AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.renewalCollectionList[0].RemoteRoadRepair ? this.renewalCollectionList[0].RemoteRoadRepair  : ''
              this.ObjRow.payAlltype = this.renewalCollectionList[0].Paymentchannel ? this.renewalCollectionList[0].Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.renewalCollectionList[0].classGiveHour ? this.renewalCollectionList[0].classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.renewalCollectionList[0].familyGiveHour ? this.renewalCollectionList[0].familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.renewalCollectionList[0].readingGiveHour ? this.renewalCollectionList[0].readingGiveHour  : ''
              this.ObjRow.classMoney = this.renewalCollectionList[0].AcademicExpenses ? this.renewalCollectionList[0].AcademicExpenses  : ''
              this.ObjRow.classHour = this.renewalCollectionList[0].AcademicClasses ? this.renewalCollectionList[0].AcademicClasses  : '' 


              this.ObjRow.happyMoney = this.renewalCollectionList[0].happyMoney ? this.renewalCollectionList[0].happyMoney  : ''
              this.ObjRow.happyHour = this.renewalCollectionList[0].happyHour ? this.renewalCollectionList[0].happyHour  : ''
              this.ObjRow.happyGiveHour = this.renewalCollectionList[0].happyGiveHour ? this.renewalCollectionList[0].happyGiveHour  : ''
              this.ObjRow.parentAwarenessMoney = this.renewalCollectionList[0].parentAwarenessMoney ? this.renewalCollectionList[0].parentAwarenessMoney  : ''
              this.ObjRow.parentAwarenessHour = this.renewalCollectionList[0].parentAwarenessHour ? this.renewalCollectionList[0].parentAwarenessHour  : ''
              this.ObjRow.parentAwarenessGiveHour = this.renewalCollectionList[0].parentAwarenessGiveHour ? this.renewalCollectionList[0].parentAwarenessGiveHour  : ''
              this.ObjRow.familyProblemMoney = this.renewalCollectionList[0].familyProblemMoney ? this.renewalCollectionList[0].familyProblemMoney  : ''
              this.ObjRow.familyProblemHour = this.renewalCollectionList[0].familyProblemHour ? this.renewalCollectionList[0].familyProblemHour  : ''
              this.ObjRow.familyProblemGiveHour = this.renewalCollectionList[0].familyProblemGiveHour ? this.renewalCollectionList[0].familyProblemGiveHour  : ''
              this.ObjRow.patriarchReplayMoney = this.renewalCollectionList[0].patriarchReplayMoney ? this.renewalCollectionList[0].patriarchReplayMoney  : ''
              this.ObjRow.patriarchReplayHour = this.renewalCollectionList[0].patriarchReplayHour ? this.renewalCollectionList[0].patriarchReplayHour  : ''
              this.ObjRow.patriarchReplayGiveHour = this.renewalCollectionList[0].patriarchReplayGiveHour ? this.renewalCollectionList[0].patriarchReplayGiveHour  : ''
              this.ObjRow.childReplayMoney = this.renewalCollectionList[0].childReplayMoney ? this.renewalCollectionList[0].childReplayMoney  : ''
              this.ObjRow.childReplayHour = this.renewalCollectionList[0].childReplayHour ? this.renewalCollectionList[0].childReplayHour  : ''
              this.ObjRow.childReplayGiveHour = this.renewalCollectionList[0].childReplayGiveHour ? this.renewalCollectionList[0].childReplayGiveHour  : ''
              this.ObjRow.educationPerceiveMoney = this.renewalCollectionList[0].educationPerceiveMoney ? this.renewalCollectionList[0].educationPerceiveMoney  : ''
              this.ObjRow.educationPerceiveHour = this.renewalCollectionList[0].educationPerceiveHour ? this.renewalCollectionList[0].educationPerceiveHour  : ''
              this.ObjRow.educationPerceiveGiveHour = this.renewalCollectionList[0].educationPerceiveGiveHour ? this.renewalCollectionList[0].educationPerceiveGiveHour  : ''
              this.ObjRow.fenCaseMoney = this.renewalCollectionList[0].fenCaseMoney ? this.renewalCollectionList[0].fenCaseMoney  : ''
              this.ObjRow.fenCaseHour = this.renewalCollectionList[0].fenCaseHour ? this.renewalCollectionList[0].fenCaseHour  : ''
              this.ObjRow.fenCaseGiveHour = this.renewalCollectionList[0].fenCaseGiveHour ? this.renewalCollectionList[0].fenCaseGiveHour  : ''

              this.ObjRow.affinityBookMoney = this.renewalCollectionList[0].affinityBookMoney ? this.renewalCollectionList[0].affinityBookMoney  : ''
              this.ObjRow.affinityBookHour = this.renewalCollectionList[0].affinityBookHour ? this.renewalCollectionList[0].affinityBookHour  : ''
              this.ObjRow.affinityBookGiveHour = this.renewalCollectionList[0].affinityBookGiveHour ? this.renewalCollectionList[0].affinityBookGiveHour  : ''

            }

            if(type === '退费'){
              this.ObjRow.projectMoney = this.Plan
              this.ObjRow.diagnoseMoney = this.diagnoseMoney
              this.ObjRow.diagnoseHour = this.diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
              this.ObjRow.studentMoney = this.studentMoney
              this.ObjRow.studentHour = this.studentHour
              this.ObjRow.studentGiveHour = this.studentGiveHour
              this.ObjRow.patriarchMoney = this.patriarchMoney
              this.ObjRow.patriarchHour = this.patriarchHour
              this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
              this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
              this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
              this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
              this.ObjRow.classMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              

              this.ObjRow.happyMoney = this.happyMoney ? this.happyMoney  : ''
              this.ObjRow.happyHour = this.happyHour ? this.happyHour  : ''
              this.ObjRow.happyGiveHour = this.happyGiveHour ? this.happyGiveHour  : ''
              this.ObjRow.parentAwarenessMoney = this.parentAwarenessMoney ? this.parentAwarenessMoney  : ''
              this.ObjRow.parentAwarenessHour = this.parentAwarenessHour ? this.parentAwarenessHour  : ''
              this.ObjRow.parentAwarenessGiveHour = this.parentAwarenessGiveHour ? this.parentAwarenessGiveHour  : ''
              this.ObjRow.familyProblemMoney = this.familyProblemMoney ? this.familyProblemMoney  : ''
              this.ObjRow.familyProblemHour = this.familyProblemHour ? this.familyProblemHour  : ''
              this.ObjRow.familyProblemGiveHour = this.familyProblemGiveHour ? this.familyProblemGiveHour  : ''
              this.ObjRow.patriarchReplayMoney = this.patriarchReplayMoney ? this.patriarchReplayMoney  : ''
              this.ObjRow.patriarchReplayHour = this.patriarchReplayHour ? this.patriarchReplayHour  : ''
              this.ObjRow.patriarchReplayGiveHour = this.patriarchReplayGiveHour ? this.patriarchReplayGiveHour  : ''
              this.ObjRow.childReplayMoney = this.childReplayMoney ? this.childReplayMoney  : ''
              this.ObjRow.childReplayHour = this.childReplayHour ? this.childReplayHour  : ''
              this.ObjRow.childReplayGiveHour = this.childReplayGiveHour ? this.childReplayGiveHour  : ''
              this.ObjRow.educationPerceiveMoney = this.educationPerceiveMoney ? this.educationPerceiveMoney  : ''
              this.ObjRow.educationPerceiveHour = this.educationPerceiveHour ? this.educationPerceiveHour  : ''
              this.ObjRow.educationPerceiveGiveHour = this.educationPerceiveGiveHour ? this.educationPerceiveGiveHour  : ''
              this.ObjRow.fenCaseMoney = this.fenCaseMoney ? this.fenCaseMoney  : ''
              this.ObjRow.fenCaseHour = this.fenCaseHour ? this.fenCaseHour  : ''
              this.ObjRow.fenCaseGiveHour = this.fenCaseGiveHour ? this.fenCaseGiveHour  : ''

              this.ObjRow.affinityBookMoney = this.affinityBookMoney ? this.affinityBookMoney  : ''
              this.ObjRow.affinityBookHour = this.affinityBookHour ? this.affinityBookHour  : ''
              this.ObjRow.affinityBookGiveHour = this.affinityBookGiveHour ? this.affinityBookGiveHour  : ''

              
            }


            console.log(this.ObjRow,'this.>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')

            axios.post(`${apiBaseUrl}/${url}`, this.ObjRow,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                  this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                  this.$emit("newModesCustomerFundingDetailEvent");
                  this.$emit("refreshOrder");
                  this.showEdit = false;
              }else{
                this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
              }
            }).catch((err)=>{
              this.$message({  message: err ,  type: "error" });
            })


          }else{
            this.$message({  message: '请输入必填项',  type: "warning" });
          }
        }else{

          if(type === '退费'){
              this.ObjRow.projectMoney = this.Plan
              this.ObjRow.diagnoseMoney = this.diagnoseMoney
              this.ObjRow.diagnoseHour = this.diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
              this.ObjRow.studentMoney = this.studentMoney
              this.ObjRow.studentHour = this.studentHour
              this.ObjRow.studentGiveHour = this.studentGiveHour
              this.ObjRow.patriarchMoney = this.patriarchMoney
              this.ObjRow.patriarchHour = this.patriarchHour
              this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
              this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
              this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
              this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
              this.ObjRow.classMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.commitRemark = Remark ? Remark  : ''
              this.ObjRow.customerId = this.customerIds
              this.ObjRow.id = this.ids


              this.ObjRow.happyMoney = this.happyMoney ? this.happyMoney  : ''
              this.ObjRow.happyHour = this.happyHour ? this.happyHour  : ''
              this.ObjRow.happyGiveHour = this.happyGiveHour ? this.happyGiveHour  : ''
              this.ObjRow.parentAwarenessMoney = this.parentAwarenessMoney ? this.parentAwarenessMoney  : ''
              this.ObjRow.parentAwarenessHour = this.parentAwarenessHour ? this.parentAwarenessHour  : ''
              this.ObjRow.parentAwarenessGiveHour = this.parentAwarenessGiveHour ? this.parentAwarenessGiveHour  : ''
              this.ObjRow.familyProblemMoney = this.familyProblemMoney ? this.familyProblemMoney  : ''
              this.ObjRow.familyProblemHour = this.familyProblemHour ? this.familyProblemHour  : ''
              this.ObjRow.familyProblemGiveHour = this.familyProblemGiveHour ? this.familyProblemGiveHour  : ''
              this.ObjRow.patriarchReplayMoney = this.patriarchReplayMoney ? this.patriarchReplayMoney  : ''
              this.ObjRow.patriarchReplayHour = this.patriarchReplayHour ? this.patriarchReplayHour  : ''
              this.ObjRow.patriarchReplayGiveHour = this.patriarchReplayGiveHour ? this.patriarchReplayGiveHour  : ''
              this.ObjRow.childReplayMoney = this.childReplayMoney ? this.childReplayMoney  : ''
              this.ObjRow.childReplayHour = this.childReplayHour ? this.childReplayHour  : ''
              this.ObjRow.childReplayGiveHour = this.childReplayGiveHour ? this.childReplayGiveHour  : ''
              this.ObjRow.educationPerceiveMoney = this.educationPerceiveMoney ? this.educationPerceiveMoney  : ''
              this.ObjRow.educationPerceiveHour = this.educationPerceiveHour ? this.educationPerceiveHour  : ''
              this.ObjRow.educationPerceiveGiveHour = this.educationPerceiveGiveHour ? this.educationPerceiveGiveHour  : ''
              this.ObjRow.fenCaseMoney = this.fenCaseMoney ? this.fenCaseMoney  : ''
              this.ObjRow.fenCaseHour = this.fenCaseHour ? this.fenCaseHour  : ''
              this.ObjRow.fenCaseGiveHour = this.fenCaseGiveHour ? this.fenCaseGiveHour  : ''

              this.ObjRow.affinityBookMoney = this.affinityBookMoney ? this.affinityBookMoney  : ''
              this.ObjRow.affinityBookHour = this.affinityBookHour ? this.affinityBookHour  : ''
              this.ObjRow.affinityBookGiveHour = this.affinityBookGiveHour ? this.affinityBookGiveHour  : ''
              
            }


            

            console.log(this.ObjRow,'this.>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')

            axios.post(`${apiBaseUrl}/${url}`, this.ObjRow,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                  this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                  this.$emit("newModesCustomerFundingDetailEvent");
                  this.$emit("refreshOrder");
                  this.showEdit = false;
              }else{
                this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
              }
            }).catch((err)=>{
              this.$message({  message: err ,  type: "error" });
            })

        }


      },


      handleViewSet(type, index, url, Remark, { PaymentTime, Paymentchannel, chargeCollectionPicture }){
        this.ObjRow.customerId = this.customerIds
        this.ObjRow.id = this.ids


        if(type != '退费'){
          if(PaymentTime && Paymentchannel && chargeCollectionPicture.length > 0){

        

            this.ObjRow.commitRemark = Remark
            this.ObjRow.chargeCollectionDate = PaymentTime ? PaymentTime  : ''

            if(type === '全款'){
              this.ObjRow.projectMoney = this.Plan
              this.ObjRow.diagnoseMoney = this.diagnoseMoney
              this.ObjRow.diagnoseHour = this.diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
              this.ObjRow.studentMoney = this.studentMoney
              this.ObjRow.studentHour = this.studentHour
              this.ObjRow.studentGiveHour = this.studentGiveHour
              this.ObjRow.patriarchMoney = this.patriarchMoney
              this.ObjRow.patriarchHour = this.patriarchHour
              this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
              this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
              this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
              this.ObjRow.chargeCollectionDate = this.PaymentTime ? this.PaymentTime  : ''
              this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
            }
            if(type === '分期'){
              this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan 
              this.ObjRow.diagnoseMoney = this.renewalCollectionListWay[0].diagnoseMoney
              this.ObjRow.diagnoseHour = this.renewalCollectionListWay[0].diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.renewalCollectionListWay[0].diagnoseGiveHour
              this.ObjRow.studentMoney = this.renewalCollectionListWay[0].studentMoney
              this.ObjRow.studentHour = this.renewalCollectionListWay[0].studentHour
              this.ObjRow.studentGiveHour = this.renewalCollectionListWay[0].studentGiveHour
              this.ObjRow.patriarchMoney = this.renewalCollectionListWay[0].patriarchMoney
              this.ObjRow.patriarchHour = this.renewalCollectionListWay[0].patriarchHour
              this.ObjRow.patriarchGiveHour = this.renewalCollectionListWay[0].patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan ? this.renewalCollectionListWay[0].Plan  : ''
              this.ObjRow.allPayMoney = this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : ''
              this.ObjRow.classMoney = this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : ''
              this.ObjRow.classHour = this.renewalCollectionListWay[0].AcademicClasses ? this.renewalCollectionListWay[0].AcademicClasses  : ''
              this.ObjRow.familyHour = this.renewalCollectionListWay[0].FamilyEducationClass ? this.renewalCollectionListWay[0].FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.renewalCollectionListWay[0].FamilyEducationExpenses ? this.renewalCollectionListWay[0].FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.renewalCollectionListWay[0].AccompanyingReadingFee ? this.renewalCollectionListWay[0].AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.renewalCollectionListWay[0].AccompanyingReading ? this.renewalCollectionListWay[0].AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.renewalCollectionListWay[0].RemoteRoadRepair ? this.renewalCollectionListWay[0].RemoteRoadRepair  : ''
              this.ObjRow.chargeCollectionDate = this.renewalCollectionListWay[0].PaymentTime ? this.renewalCollectionListWay[0].PaymentTime  : ''
              this.ObjRow.payAlltype = this.renewalCollectionListWay[0].Paymentchannel ? this.renewalCollectionListWay[0].Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.renewalCollectionListWay[0].classGiveHour ? this.renewalCollectionListWay[0].classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.renewalCollectionListWay[0].familyGiveHour ? this.renewalCollectionListWay[0].familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.renewalCollectionListWay[0].readingGiveHour ? this.renewalCollectionListWay[0].readingGiveHour  : ''
              this.ObjRow.contractCost = this.contractAmount ? this.contractAmount  : ''
              
            }

            if(type === '续费'){
              this.ObjRow.projectMoney = this.renewalCollectionList[0].Plan ? this.renewalCollectionList[0].Plan  : ''
              this.ObjRow.diagnoseMoney = this.renewalCollectionList[0].diagnoseMoney ? this.renewalCollectionList[0].diagnoseMoney  : ''
              this.ObjRow.diagnoseHour = this.renewalCollectionList[0].diagnoseHour ? this.renewalCollectionList[0].diagnoseHour  : ''
              this.ObjRow.diagnoseGiveHour = this.renewalCollectionList[0].diagnoseGiveHour ? this.renewalCollectionList[0].diagnoseGiveHour  : ''
              this.ObjRow.studentMoney = this.renewalCollectionList[0].studentMoney ? this.renewalCollectionList[0].studentMoney  : ''
              this.ObjRow.studentHour = this.renewalCollectionList[0].studentHour ? this.renewalCollectionList[0].studentHour  : ''
              this.ObjRow.studentGiveHour = this.renewalCollectionList[0].studentGiveHour ? this.renewalCollectionList[0].studentGiveHour  : ''
              this.ObjRow.patriarchMoney = this.renewalCollectionList[0].patriarchMoney ? this.renewalCollectionList[0].patriarchMoney  : ''
              this.ObjRow.patriarchHour = this.renewalCollectionList[0].patriarchHour ? this.renewalCollectionList[0].patriarchHour  : ''
              this.ObjRow.patriarchGiveHour = this.renewalCollectionList[0].patriarchGiveHour ? this.renewalCollectionList[0].patriarchGiveHour  : ''
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.renewalCollectionList[0].Plan ? this.renewalCollectionList[0].Plan  : ''
              this.ObjRow.allPayMoney = this.renewalCollectionList[0].AcademicExpenses ? this.renewalCollectionList[0].AcademicExpenses  : ''
              this.ObjRow.classHour = this.renewalCollectionList[0].AcademicClasses ? this.renewalCollectionList[0].AcademicClasses  : ''
              this.ObjRow.familyHour = this.renewalCollectionList[0].FamilyEducationClass ? this.renewalCollectionList[0].FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.renewalCollectionList[0].FamilyEducationExpenses ? this.renewalCollectionList[0].FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.renewalCollectionList[0].AccompanyingReadingFee ? this.renewalCollectionList[0].AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.renewalCollectionList[0].AccompanyingReading ? this.renewalCollectionList[0].AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.renewalCollectionList[0].RemoteRoadRepair ? this.renewalCollectionList[0].RemoteRoadRepair  : ''
              this.ObjRow.payAlltype = this.renewalCollectionList[0].Paymentchannel ? this.renewalCollectionList[0].Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.renewalCollectionList[0].classGiveHour ? this.renewalCollectionList[0].classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.renewalCollectionList[0].familyGiveHour ? this.renewalCollectionList[0].familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.renewalCollectionList[0].readingGiveHour ? this.renewalCollectionList[0].readingGiveHour  : ''
              this.ObjRow.classMoney = this.renewalCollectionList[0].AcademicExpenses ? this.renewalCollectionList[0].AcademicExpenses  : ''
              this.ObjRow.classHour = this.renewalCollectionList[0].AcademicClasses ? this.renewalCollectionList[0].AcademicClasses  : '' 

            }

            if(type === '退费'){
              this.ObjRow.projectMoney = this.Plan
              this.ObjRow.diagnoseMoney = this.diagnoseMoney
              this.ObjRow.diagnoseHour = this.diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
              this.ObjRow.studentMoney = this.studentMoney
              this.ObjRow.studentHour = this.studentHour
              this.ObjRow.studentGiveHour = this.studentGiveHour
              this.ObjRow.patriarchMoney = this.patriarchMoney
              this.ObjRow.patriarchHour = this.patriarchHour
              this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
              this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
              this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
              this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
              this.ObjRow.classMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
            }


            console.log(this.ObjRow,'this.>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')

            axios.post(`${apiBaseUrl}/${url}`, this.ObjRow,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                  this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                  this.$emit("newModesCustomerFundingDetailEvent");
                  this.$emit("refreshOrder");
                  this.showEdit = false;
              }else{
                this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
              }
            }).catch((err)=>{
              this.$message({  message: err ,  type: "error" });
            })


          }else{
            this.$message({  message: '请输入必填项',  type: "warning" });
          }
        }else{

          if(type === '退费'){
              this.ObjRow.projectMoney = this.Plan
              this.ObjRow.diagnoseMoney = this.diagnoseMoney
              this.ObjRow.diagnoseHour = this.diagnoseHour
              this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
              this.ObjRow.studentMoney = this.studentMoney
              this.ObjRow.studentHour = this.studentHour
              this.ObjRow.studentGiveHour = this.studentGiveHour
              this.ObjRow.patriarchMoney = this.patriarchMoney
              this.ObjRow.patriarchHour = this.patriarchHour
              this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
              this.ObjRow.chargeCollectionPicture = chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : '[]'
              this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
              this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
              this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
              this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
              this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
              this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
              this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
              this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
              this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
              this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
              this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
              this.ObjRow.classMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
              this.ObjRow.commitRemark = Remark ? Remark  : ''
              this.ObjRow.customerId = this.customerIds
              this.ObjRow.id = this.ids
            }


            

            console.log(this.ObjRow,'this.>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')

            axios.post(`${apiBaseUrl}/${url}`, this.ObjRow,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                  this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                  this.$emit("newModesCustomerFundingDetailEvent");
                  this.$emit("refreshOrder");
                  this.showEdit = false;
              }else{
                this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
              }
            }).catch((err)=>{
              this.$message({  message: err ,  type: "error" });
            })

        }


      },

      handleSetWay (type) {
          this.setWay = type;
      },

      handleEventElUploadSubt(flileList,type, index) {

        if  (type === '分期') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionListWay[index].chargeCollectionPicture = flileList
          }
          
        }

        if  (type === '全款') {
          if (flileList && flileList.length > 0) {
              this.chargeCollectionPicture = flileList
          }
          
        }

        if  (type === '定金') {
         if (flileList && flileList.length > 0) {
            this.fileAllLists = flileList
         }
          
        }

        if  (type === '续费') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionList[index].renewCollectionPicture = flileList
          }
        }

        
        this.isShowElupload = false;
      },

      handleEventElUpload(flileList, type, index) {

        
        if  (type === '分期') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionListWay[index].chargeCollectionPicture = flileList
          }
          
        }

        if  (type === '全款') {
          if (flileList && flileList.length > 0) {
              this.chargeCollectionPicture = flileList
          }
          
        } 

        if  (type === '续费') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionList[index].renewCollectionPicture = flileList
          }
        }

        this.isShowElupload = false;
      },

      handleUploadDelet(file) {
        this.fileAllLists = []
      },

      handleUpload(type,index,list) {
        
       if(type === '全款'){
           this.isTpyeImg = '全款';
        }

        if(type === '分期'){
           this.renewalCollectionListWayIndexList = list ? list : []
           this.isTpyeImg = '分期';
        }

        if(type === '定金'){
           this.isTpyeImg = '定金';
        }

        if(type === '续费'){
           this.isTpyeImg = '续费';
        }

        this.Uploadtypes = type
        this.isTypeListindex = index

        this.isShowElupload = true

      },

      handleToString (num) {
        const CN_NUM = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        const CN_UNIT = ['', '十', '百', '千'];
        const CN_SECTION = ['', '万', '亿', '万亿'];

        // 非数字处理
        if (typeof num !== 'number' || isNaN(num)) return '';

        // 处理负数
        if (num < 0) {
            return '负' + arabicToChinese(-num);
        }

        // 分割整数与小数部分
        const parts = num.toFixed(2).split('.');
        const intPart = parts[0];
        const decPart = parts[1];

        let result = '';
        let zeroFlag = false;

        // 分段处理整数部分（每4位一组）
        const sections = [];
        let temp = intPart;
        while (temp.length > 4) {
            sections.unshift(temp.slice(-4));
            temp = temp.slice(0, -4);
        }
        sections.unshift(temp.padStart(4, '0').slice(-4)); // 补齐前导0

        for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            let sectionStr = '';
            zeroFlag = false;

            for (let j = 0; j < section.length; j++) {
                const digit = parseInt(section[j]);
                const unit = CN_UNIT[section.length - j - 1];

                if (digit === 0) {
                    zeroFlag = true;
                } else {
                    if (zeroFlag) {
                        // sectionStr += CN_NUM[0];
                        zeroFlag = false;
                    }
                    sectionStr += CN_NUM[digit] + (digit !== 0 ? unit : '');
                }
            }

            if (sectionStr !== '') {
                // 去掉末尾多余的“零”
                if (sectionStr.endsWith('零')) {
                    sectionStr = sectionStr.slice(0, -1);
                }
                result += sectionStr + CN_SECTION[sections.length - i - 1];
            }
        }

        // 如果整数部分为空，表示是纯小数
        if (!result) {
            result = CN_NUM[0];
        }

        // 处理小数部分
        if (decPart && decPart !== '00') {
            result += '点';
            for (let i = 0; i < decPart.length; i++) {
                const digit = parseInt(decPart[i]);
                result += CN_NUM[digit];
            }
        }

        return result;
      },


      handleView(value, width = 0, height = 0){
        this.isImg = true
        this.imgWidth = width
        this.imgHeight = height 
        this.isImgs = value
      },

      closeisImg(){
        this.isImg = false
        this.isImgs = ''
        this.imgWidth = 0
        this.imgHeight = 0
      },


      handleClear(event) {
        console.log('Selected value:', event);
        this.remarks = ''
        this.detailedAddress = ''
        this.newaddress = ''
      },


      // 模拟从后端获取搜索结果
      async querySearchAsync(queryString, cb) {
        if (!queryString) {
          cb([]);
          return;
        }

        // 模拟调用后端接口获取数据
        const results = await this.fetchAddressesFromBackend(queryString);

        // 调用回调函数，传递搜索结果
        cb(results);
      },

      // 模拟后端接口请求
      fetchAddressesFromBackend(query) {
          return new Promise((resolve, reject) => {
            let dateObj = {
              regionName: this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '',
              keyword: query
            }
            axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                console.log(res.data.data, '获取地址列表')
                resolve(res.data.data.map(item => ({
                      value: item.addressTitleName,
                      city: item.districtName,
                      district: item.addressFollow,
                      address: item.addressFollow,
                      latitude: item.latitude,
                      precisionLng: item.precisionLng,
                })));
              } else {
                resolve([]);
                this.$message.error(err);
              }
            }).catch(err => {
              this.$message.error(err);
              reject(new Error('JSONP请求失败'));
            })
        })

   
        
        // return new Promise((resolve, reject) => {
        //     const regionName = this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '';
        //     const apiKey = 'V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD';
        //     const callbackName = `jsonpCallback_${Date.now()}`;
        //     const script = document.createElement('script');
        //     script.src = `https://apis.map.qq.com/ws/place/v1/suggestion?keyword=${encodeURIComponent(query)}&region=${regionName}&key=${apiKey}&output=jsonp&callback=${callbackName}`;

        //     window[callbackName] = (data) => {
        //         document.body.removeChild(script);
        //         delete window[callbackName];
        //         if (data.status === 0) {
        //             resolve(data.data.map(item => ({
        //                 value: item.title,
        //                 city: item.city,
        //                 district: item.district,
        //                 address: item.address,
        //                 location: item.location,

        //             })));
        //         } else {
        //             console.error('腾讯地图API错误:', data.message);
        //             resolve([]);
        //         }
        //     };

        //     script.onerror = () => {
        //         document.body.removeChild(script);
        //         delete window[callbackName];
        //         reject(new Error('JSONP请求失败'));
        //     };

        //     document.body.appendChild(script);
        // });
      },

      // 当用户选择一个建议时触发
      handleSelect(item) {
        console.log('用户选择了:', item);
        this.infoObj = item
        this.newaddress = item.value; // 确保选中的值绑定到表单中
      },

      handleautocompleteClear(event) {
        this.infoObj = {};
      },


      changeisWantToContinueTheClass (val) {
          console.log(val, '(changeisWantToContinueTheClass)')
      },

      changeisThereACharge (val) {
          console.log(val, '(changeisThereACharge)')
      },

      changeisThereACharge1 (val) {
          console.log(val, '(changeisThereACharge1)')
      },

      changeisThereARefund (val) {
          console.log(val, '(changeisThereARefund)')
          if(val === 2){
            this.isCustomsDeclarationchengRemarks = ''
          }
      },


      closeisOrderStatus(val) {
        this.isOrderStatusTextarea = ''
        this.isOrderStatus = false
      },

      changeCustomerFunding (val) {

      },

      changeOrderStatus (val) {
          if(val === 2){
             this.isOrderStatus = true
          }else{
            this.isOrderStatus = false
          }
      },


      addInput1 () {
        this.renewalCollectionList.push({
          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          RemoteRoadRepair:'',
          PaymentTime:'',
          Paymentchannel:'',
          classGiveHour:'', 
          familyGiveHour:'',
          readingGiveHour:'',
          DiagnosticClass : '',
          DiagnosticClassFee : '',
          DiagnosticClassFeeGift : '',
          studentMoney:'',
          studentHour:'',
          studentGiveHour:'',
          patriarchMoney:'',
          patriarchHour:'',
          patriarchGiveHour:'',
          diagnoseMoney:'',
          diagnoseHour:'',
          diagnoseGiveHour:'',
          renewCollectionPicture:[],
        })
      },

      addInput11 () {
        this.renewalCollectionListWay.push({
            Plan:'',
            diagnoseMoney:'',
            diagnoseHour:'',
            diagnoseGiveHour:'',
            AcademicExpenses:'',
            AcademicClasses:'',
            classGiveHour:'',
            FamilyEducationExpenses:'',
            FamilyEducationClass:'',
            familyGiveHour:'',
            studentMoney:'',
            studentHour:'',
            studentGiveHour:'',
            patriarchMoney:'',
            patriarchHour:'',
            patriarchGiveHour:'',
            AccompanyingReadingFee:'',
            AccompanyingReading:'',
            readingGiveHour:'',
            RemoteRoadRepair:'',
            PaymentTime:'',
            Paymentchannel:'',
            chargeCollectionPicture:[],
        })
      },

      removeItem11 () {
        if (this.renewalCollectionListWay.length > 1) {
            this.renewalCollectionListWay.pop()
        } else {
            this.renewalCollectionListWay.splice(0, this.renewalCollectionListWay.length)
        }
      },

      removeItem1 () {
        if (this.renewalCollectionList.length > 1) {
            this.renewalCollectionList.pop()
        } else {
            this.renewalCollectionList.splice(0, this.renewalCollectionList.length)
        }
      },

      startTimeSelect (val, row) {

        if (val == "start") {
          this.order.OffTimeHour = row
        } else if (val == "end") {
          this.order.offEndTime = row
        } else if (val == "start1") {
          this.order.startTimeHour = row
        } else {
          this.order.onEndTime = row
        }

      },

      endTimeSelect (val) {
        this.order.offEndTime = val
      },
      init(customerId,type){

        this.customerId = customerId
        this.isDetail = type === 2 ? true : false
        this.showEdit = true
        this.isClassType = 1 

      },
      init1 (customerId,type) {
      
          
          this.isDetail = type === 2 ? true : false
          this.showEdit = true
          axios.get(`${apiBaseUrl}/customerInformationCollectionAudit/getOne/${customerId}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {

                
                


                  this.customerIds = res.data.data.customerId
                  this.ids = res.data.data.id

                  console.log(this.typeCustomerFunding,'详情>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')

                        // 是否为分期 || 全款
                  this.setWay = res.data.data.collectionType === 1 ? '全款' : res.data.data.collectionType === 2 ? '分期' : ''

                  this.order = res.data.data


                  this.isClassType = res.data.data.classType

                  this.costType = res.data.data.costType




                  this.isCustomerStatus = res.data.data.customerType
                  this.customerReturnType = res.data.data.customerReturnType

                  this.isClassTypeTxts = res.data.data.classType === 1 ? '规划' : res.data.data.classType === 2 ? '线下' : res.data.data.classType === 3 ? '纯补课' : ''

                  this.chengRemarks = res.data.data.commitRemark
                  this.ApprovalPeople = res.data.data.auditId


                  this.fileAllLists = [{ url: res.data.data.uploadingPicture }]


                  // =========================================================(定金)=======================================================
                  this.OrderStatus = res.data.data.orderStatus
                  this.paymentAmount = res.data.data.customerPaymoney
                  this.paymentAmountTime = res.data.data.customerPaytime
                  this.paymentAmountChannel = res.data.data.payType
                  this.paymentAmountCourse = res.data.data.customerHour
                  this.isOrderStatusTextarea = res.data.data.notCustomerRemark

                  const picData = res.data.data.diagnosisCollectionPicture;
                  if (typeof picData === 'string') {
                    try {
                      this.fileAllLists_DINGJIN = JSON.parse(picData);
                    } catch (e) {
                      this.fileAllLists_DINGJIN = [];
                    }
                  } else {
                    this.fileAllLists_DINGJIN = [];
                  }




                  


                  // =========================================================(成单)=======================================================
                  // (1) 是否收费
                  this.isThereACharge = res.data.data.customerIsallpay
                  this.isCustomsDeclaration = res.data.data.isClose ? res.data.data.isClose : 2
                  this.isCustomsDeclarationchengRemarks = res.data.data.closeCause ? res.data.data.closeCause : ''   
                  
                  this.doubtContent = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []
                  // =========================================================(成单分期)=======================================================
                  
                  if (this.costType === 2 && res.data.data.categoryType === 1) {
                        this.renewalCollectionListWay = []
                        this.renewalCollectionListWay.push(
                                  {
                                      Plan: res.data.data.projectMoney || '',
                                      diagnoseMoney: res.data.data.diagnoseMoney || '',
                                      AcademicExpenses: res.data.data.customerAllpaymoney|| '',
                                      FamilyEducationExpenses: res.data.data.familyMoney|| '',
                                      patriarchMoney: res.data.data.patriarchMoney || '',
                                      studentMoney: res.data.data.studentMoney || '',
                                      AccompanyingReadingFee: res.data.data.readingPartnerMoney || '',
                                      RemoteRoadRepair: res.data.data.wayMoney || '',
                                      PaymentTime: res.data.data.stagesDate || '',
                                      Paymentchannel: res.data.data.payType || '',
                                      chargeCollectionPicture: res.data.data.stagesPicture ? JSON.parse(res.data.data.stagesPicture) : [],
                                      diagnoseHour: res.data.data.diagnoseHour,
                                      diagnoseGiveHour: res.data.data.diagnoseGiveHour,
                                      studentHour: res.data.data.studentHour,
                                      studentGiveHour: res.data.data.studentGiveHour,
                                      patriarchHour: res.data.data.patriarchHour,
                                      patriarchGiveHour: res.data.data.patriarchGiveHour,
                                      AcademicClasses: res.data.data.classHour ? res.data.data.classHour : '',
                                      FamilyEducationClass: res.data.data.familyHour ? res.data.data.familyHour : '',
                                      AccompanyingReading: res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour : '',
                                      PaymentTime: res.data.data.payTime ? res.data.data.payTime : '',
                                      Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype) : '',
                                      classGiveHour: res.data.data.classGiveHour ? res.data.data.classGiveHour : '',
                                      familyGiveHour: res.data.data.familyGiveHour ? res.data.data.familyGiveHour : '',
                                      readingGiveHour: res.data.data.readingGiveHour ? res.data.data.readingGiveHour : '',
                                      sumMoney: res.data.data.sumMoney ? res.data.data.sumMoney : '',              //收款金额
                                      stagesDate: res.data.data.stagesDate ? res.data.data.stagesDate : '',        //收款时间
                                      payType: res.data.data.payType ? res.data.data.payType : '',                 //收款渠道


                                      Plan :  res.data.data.projectMoney ? res.data.data.projectMoney  : '',
                                      AcademicExpenses :  res.data.data.classMoney ? res.data.data.classMoney  : '',
                                      AcademicClasses :  res.data.data.classHour ? res.data.data.classHour  : '',
                                      FamilyEducationClass :  res.data.data.familyHour ? res.data.data.familyHour  : '',
                                      FamilyEducationExpenses :  res.data.data.familyMoney ? res.data.data.familyMoney  : '',
                                      AccompanyingReadingFee :  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : '',
                                      AccompanyingReading :  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : '',
                                      RemoteRoadRepair :  res.data.data.wayMoney ? res.data.data.wayMoney  : '',
                                      PaymentTime :  res.data.data.customerAllpaytime ? res.data.data.customerAllpaytime  : '',
                                      Paymentchannel :  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                                      classGiveHour :  res.data.data.classGiveHour ? res.data.data.classGiveHour  : '',
                                      familyGiveHour :  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : '',
                                      readingGiveHour :  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : '',
                                      diagnoseMoney :  res.data.data.diagnoseMoney,
                                      diagnoseHour :  res.data.data.diagnoseHour,
                                      diagnoseGiveHour :  res.data.data.diagnoseGiveHour,
                                      studentMoney :  res.data.data.studentMoney,
                                      studentHour :  res.data.data.studentHour,
                                      studentGiveHour :  res.data.data.studentGiveHour,
                                      patriarchMoney :  res.data.data.patriarchMoney,
                                      patriarchHour :  res.data.data.patriarchHour,
                                      patriarchGiveHour :  res.data.data.patriarchGiveHour,
                                      chargeCollectionPicture :  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],

                                      periodsNumber:  res.data.data.periodsNumber,
                                      PaymentTime: res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : '',
                                      Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype) : '',
                                      chargeCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],

                                    }
                      )
                            

                    console.log(this.renewalCollectionListWay , '11111111111111111')

                   
                  } else {
                    this.renewalCollectionListWay = [];
                  }


                  



                  // (2) 是否续费
                  this.isYouWantToRenew = res.data.data.isRenew
                  // (3) 是否退费
                  this.isThereARefund = res.data.data.isReturnPremium
                  // =========================================================(退费)=======================================================
                  this.isWantToContinueTheClass = res.data.data.isContinueType

                 

                if(res.data.data.costType === 1 && res.data.data.categoryType === 1){
                    this.Plan = res.data.data.projectMoney
                    this.AcademicExpenses = res.data.data.customerAllpaymoney
                    this.AcademicClasses = res.data.data.classHour
                    this.FamilyEducationExpenses = res.data.data.familyMoney
                    this.FamilyEducationClass = res.data.data.familyHour
                    this.AccompanyingReadingFee = res.data.data.readingPartnerMoney
                    this.AccompanyingReading = res.data.data.readingPartnerHour
                    this.RemoteRoadRepair = res.data.data.wayMoney
                    this.PaymentTime = res.data.data.customerAllpaytime
                    this.Paymentchannel = Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype) : ''
                    this.classGiveHour = res.data.data.classGiveHour
                    this.familyGiveHour = res.data.data.familyGiveHour
                    this.readingGiveHour = res.data.data.readingGiveHour
                    
                }
                

                this.contractAmount = res.data.data.contractCost
                
        

                if(this.costType === 1 && res.data.data.categoryType === 1){

                    this.Plan =  res.data.data.projectMoney ? res.data.data.projectMoney  : ''
                    this.AcademicExpenses =  res.data.data.classMoney ? res.data.data.classMoney  : ''
                    this.AcademicClasses =  res.data.data.classHour ? res.data.data.classHour  : ''
                    this.FamilyEducationClass =  res.data.data.familyHour ? res.data.data.familyHour  : ''
                    this.FamilyEducationExpenses =  res.data.data.familyMoney ? res.data.data.familyMoney  : ''
                    this.AccompanyingReadingFee =  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : ''
                    this.AccompanyingReading =  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : ''

                    this.RemoteRoadRepair =  res.data.data.wayMoney ? res.data.data.wayMoney  : ''
                    this.PaymentTime =  res.data.data.customerAllpaytime ? res.data.data.customerAllpaytime  : ''
                    this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                    this.classGiveHour =  res.data.data.classGiveHour ? res.data.data.classGiveHour  : ''
                    this.familyGiveHour =  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : ''
                    this.readingGiveHour =  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : ''
                    
                    this.diagnoseMoney =  res.data.data.diagnoseMoney
                    this.diagnoseHour =  res.data.data.diagnoseHour
                    this.diagnoseGiveHour =  res.data.data.diagnoseGiveHour
                    this.studentMoney =  res.data.data.studentMoney
                    this.studentHour =  res.data.data.studentHour
                    this.studentGiveHour =  res.data.data.studentGiveHour
                    this.patriarchMoney =  res.data.data.patriarchMoney
                    this.patriarchHour =  res.data.data.patriarchHour
                    this.patriarchGiveHour =  res.data.data.patriarchGiveHour
                    this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []

                    this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
                    this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                    this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []

                    

                }


                // (2) 是否续费
                this.isYouWantToRenew = res.data.data.isRenew === 1 ? 1 : 2
                


                if(this.costType === 3 && res.data.data.categoryType === 1){
                          this.renewalCollectionList = []
                          this.renewalCollectionList.push(
                          {

                                Plan: res.data.data.projectMoney,
                                AcademicExpenses : res.data.data.renewMoney,
                                AcademicClasses : res.data.data.classHourRenew,
                                FamilyEducationExpenses : res.data.data.familyMoney,
                                FamilyEducationClass : res.data.data.familyHourRenew,
                                AccompanyingReadingFee : res.data.data.readingPartnerMoney,
                                AccompanyingReading : res.data.data.readingPartnerHour,
                                RemoteRoadRepair: res.data.data.wayMoney,
                                PaymentTime : res.data.data.renewTime,
                                Paymentchannel : res.data.data.renewType,
                                classGiveHour: res.data.data.classGiveHour,
                                familyGiveHour: res.data.data.familyGiveHour,
                                readingGiveHour: res.data.data.readingGiveHour,

                                diagnoseHour: res.data.data.diagnoseHour || '',
                                diagnoseMoney: res.data.data.diagnoseMoney || '',
                                diagnoseGiveHour: res.data.data.diagnoseGiveHour || '',
                                patriarchHour: res.data.data.patriarchHour || '',
                                patriarchGiveHour: res.data.data.patriarchGiveHour || '',
                                patriarchMoney: res.data.data.patriarchMoney || '',
                                studentHour: res.data.data.studentHour || '',
                                studentGiveHour: res.data.data.studentGiveHour || '',
                                studentMoney: res.data.data.studentMoney || '',
                                renewCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],

                                sumMoney: res.data.data.sumMoney,            //收款金额
                                renewTime: res.data.data.renewTime,          //收款时间
                                renewType: res.data.data.renewType,          //收款渠道

                                Plan:  res.data.data.projectMoney ? res.data.data.projectMoney  : '',
                                AcademicExpenses:  res.data.data.classMoney ? res.data.data.classMoney  : '',
                                AcademicClasses:  res.data.data.classHour ? res.data.data.classHour  : '',
                                FamilyEducationClass:  res.data.data.familyHour ? res.data.data.familyHour  : '',
                                FamilyEducationExpenses:  res.data.data.familyMoney ? res.data.data.familyMoney  : '',
                                AccompanyingReadingFee:  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : '',
                                AccompanyingReading:  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : '',
                                RemoteRoadRepair:  res.data.data.wayMoney ? res.data.data.wayMoney  : '',
                                PaymentTime:  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate  : '',
                                Paymentchannel:  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                                classGiveHour:  res.data.data.classGiveHour ? res.data.data.classGiveHour  : '',
                                familyGiveHour:  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : '',
                                readingGiveHour:  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : '',
                                diagnoseMoney:  res.data.data.diagnoseMoney,
                                diagnoseHour:  res.data.data.diagnoseHour,
                                diagnoseGiveHour:  res.data.data.diagnoseGiveHour,
                                studentMoney:  res.data.data.studentMoney,
                                studentHour:  res.data.data.studentHour,
                                studentGiveHour:  res.data.data.studentGiveHour,
                                patriarchMoney:  res.data.data.patriarchMoney,
                                patriarchHour:  res.data.data.patriarchHour,
                                patriarchGiveHour:  res.data.data.patriarchGiveHour,
                                chargeCollectionPicture:  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],
                                periodsNumber:  res.data.data.periodsNumber ? res.data.data.periodsNumber : '',

                            }  

                        )


                          

                          console.log(this.renewalCollectionList, '222222222222222222222222222222')
                }

                    

              // (3) 是否退费
              this.isThereARefund = res.data.data.isReturnPremium === 0 ? '' : res.data.data.isReturnPremium

              // =========================================================(退费)=======================================================
              this.isWantToContinueTheClass = res.data.data.isContinueType



              if(this.typeCustomerFunding === '退费'){
                  this.isCustomerStatus = res.data.data.customerReturnType
              }


              if(this.costType === 4 && res.data.data.categoryType === 1){


                // res.data.data = JSON.parse(res.data.data)

                console.log(res.data.data, '0000000000000000000000000000000000000000=========》》》》》》》》》')
              
                this.AcademicExpenses = res.data.data.classMoney
                this.PaymentTime = res.data.data.returnPremiumDate
                this.Paymentchannel = res.data.data.returnPremiumPayType
                this.AcademicClasses = res.data.data.returnPremiumHour


                this.Plan = res.data.data.projectMoney
                this.FamilyEducationExpenses = res.data.data.familyMoney
                this.FamilyEducationClass = res.data.data.familyHourRenew
                this.AccompanyingReadingFee = res.data.data.readingPartnerMoney
                this.AccompanyingReading = res.data.data.readingPartnerHour
                this.classGiveHour = res.data.data.classGiveHour
                this.familyGiveHour = res.data.data.familyGiveHour
                this.readingGiveHour = res.data.data.readingGiveHour
                this.studentMoney = res.data.data.studentMoney
                this.diagnoseMoney = res.data.data.diagnoseMoney,
                this.diagnoseHour = res.data.data.diagnoseHour,
                this.diagnoseGiveHour = res.data.data.diagnoseGiveHour,
                this.studentHour = res.data.data.studentHour,
                this.studentGiveHour  = res.data.data.studentGiveHour,
                this.patriarchMoney = res.data.data.patriarchMoney,
                this.patriarchHour  = res.data.data.patriarchHour,
                this.patriarchGiveHour = res.data.data.patriarchGiveHour,
                this.chargeCollectionPicture = res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
                this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
            


                this.Plan =  res.data.data.projectMoney ? res.data.data.projectMoney  : ''
                this.AcademicExpenses =  res.data.data.classMoney ? res.data.data.classMoney  : ''
                this.AcademicClasses =  res.data.data.classHour ? res.data.data.classHour  : ''
                this.FamilyEducationClass =  res.data.data.familyHour ? res.data.data.familyHour  : ''
                this.FamilyEducationExpenses =  res.data.data.familyMoney ? res.data.data.familyMoney  : ''
                this.AccompanyingReadingFee =  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : ''
                this.AccompanyingReading =  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : ''
                this.RemoteRoadRepair =  res.data.data.wayMoney ? res.data.data.wayMoney  : ''
                this.PaymentTime =  res.data.data.customerAllpaytime ? res.data.data.customerAllpaytime  : ''
                this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                this.classGiveHour =  res.data.data.classGiveHour ? res.data.data.classGiveHour  : ''
                this.familyGiveHour =  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : ''
                this.readingGiveHour =  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : ''
                this.diagnoseMoney =  res.data.data.diagnoseMoney
                this.diagnoseHour =  res.data.data.diagnoseHour
                this.diagnoseGiveHour =  res.data.data.diagnoseGiveHour
                this.studentMoney =  res.data.data.studentMoney
                this.studentHour =  res.data.data.studentHour
                this.studentGiveHour =  res.data.data.studentGiveHour
                this.patriarchMoney =  res.data.data.patriarchMoney
                this.patriarchHour =  res.data.data.patriarchHour
                this.patriarchGiveHour =  res.data.data.patriarchGiveHour
                this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
                this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []



                if(res.data.data.wayMoney){
                  this.RemoteRoadRepair = res.data.data.wayMoney
                }
              }






              if( res.data.data.costType === 1 && res.data.data.categoryType === 2){
                      this.isTypeLve = res.data.data.categoryType === 2 ? 2 : 1
                      
                      if(this.isTypeLve === 2){

                          this.happyMoney = res.data.data.happyMoney
                          this.happyHour = res.data.data.happyHour
                          this.happyGiveHour = res.data.data.happyGiveHour
                          this.parentAwarenessMoney = res.data.data.parentAwarenessMoney
                          this.parentAwarenessHour = res.data.data.parentAwarenessHour
                          this.parentAwarenessGiveHour = res.data.data.parentAwarenessGiveHour
                          this.familyProblemMoney = res.data.data.familyProblemMoney
                          this.familyProblemHour = res.data.data.familyProblemHour
                          this.familyProblemGiveHour = res.data.data.familyProblemGiveHour
                          this.patriarchReplayMoney = res.data.data.patriarchReplayMoney
                          this.patriarchReplayHour = res.data.data.patriarchReplayHour
                          this.patriarchReplayGiveHour = res.data.data.patriarchReplayGiveHour
                          this.childReplayMoney = res.data.data.childReplayMoney
                          this.childReplayHour = res.data.data.childReplayHour
                          this.childReplayGiveHour = res.data.data.childReplayGiveHour
                          this.educationPerceiveMoney = res.data.data.educationPerceiveMoney
                          this.educationPerceiveHour = res.data.data.educationPerceiveHour
                          this.educationPerceiveGiveHour = res.data.data.educationPerceiveGiveHour
                          this.fenCaseMoney = res.data.data.fenCaseMoney
                          this.fenCaseHour = res.data.data.fenCaseHour
                          this.fenCaseGiveHour = res.data.data.fenCaseGiveHour


                          this.affinityBookMoney = res.data.data.affinityBookMoney
                          this.affinityBookHour = res.data.data.affinityBookHour
                          this.affinityBookGiveHour = res.data.data.affinityBookGiveHour

                          this.PaymentTime = res.data.data.chargeCollectionDate
                          this.Paymentchannel = Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                          this.chargeCollectionPicture = res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                          this.doubtContent = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []

                      }
            }


           if(res.data.data.costType === 2 && res.data.data.categoryType === 2){
                      this.isTypeLve = res.data.data.categoryType === 2 ? 2 : 1
                      
                      if(this.isTypeLve === 2){

                          this.renewalCollectionListWay = []
                          this.renewalCollectionListWay.push({
                                happyMoney: res.data.data.happyMoney,
                                happyHour: res.data.data.happyHour,
                                happyGiveHour: res.data.data.happyGiveHour,
                                parentAwarenessMoney: res.data.data.parentAwarenessMoney,
                                parentAwarenessHour: res.data.data.parentAwarenessHour,
                                parentAwarenessGiveHour: res.data.data.parentAwarenessGiveHour,
                                familyProblemMoney: res.data.data.familyProblemMoney,
                                familyProblemHour: res.data.data.familyProblemHour,
                                familyProblemGiveHour: res.data.data.familyProblemGiveHour,
                                patriarchReplayMoney: res.data.data.patriarchReplayMoney,
                                patriarchReplayHour: res.data.data.patriarchReplayHour,
                                patriarchReplayGiveHour: res.data.data.patriarchReplayGiveHour,
                                childReplayMoney: res.data.data.childReplayMoney,
                                childReplayHour: res.data.data.childReplayHour,
                                childReplayGiveHour: res.data.data.childReplayGiveHour,
                                educationPerceiveMoney: res.data.data.educationPerceiveMoney,
                                educationPerceiveHour: res.data.data.educationPerceiveHour,
                                educationPerceiveGiveHour: res.data.data.educationPerceiveGiveHour,
                                fenCaseMoney: res.data.data.fenCaseMoney,
                                fenCaseHour: res.data.data.fenCaseHour,
                                fenCaseGiveHour: res.data.data.fenCaseGiveHour,
                                PaymentTime: res.data.data.chargeCollectionDate,
                                Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                                chargeCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],
                                doubtContent: res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : [],


                                affinityBookMoney: res.data.data.affinityBookMoney,
                                affinityBookHour: res.data.data.affinityBookHour,
                                affinityBookGiveHour: res.data.data.affinityBookGiveHour

                          })
                      }
              }


             if( res.data.data.costType === 3 && res.data.data.categoryType === 2){
                      this.isTypeLves = res.data.data.categoryType === 2 ? 2 : 1
                      if(this.isTypeLves === 2){
                        

                          this.renewalCollectionList = []
                          this.renewalCollectionList.push({
                                happyMoney: res.data.data.happyMoney,
                                happyHour: res.data.data.happyHour,
                                happyGiveHour: res.data.data.happyGiveHour,
                                parentAwarenessMoney: res.data.data.parentAwarenessMoney,
                                parentAwarenessHour: res.data.data.parentAwarenessHour,
                                parentAwarenessGiveHour: res.data.data.parentAwarenessGiveHour,
                                familyProblemMoney: res.data.data.familyProblemMoney,
                                familyProblemHour: res.data.data.familyProblemHour,
                                familyProblemGiveHour: res.data.data.familyProblemGiveHour,
                                patriarchReplayMoney: res.data.data.patriarchReplayMoney,
                                patriarchReplayHour: res.data.data.patriarchReplayHour,
                                patriarchReplayGiveHour: res.data.data.patriarchReplayGiveHour,
                                childReplayMoney: res.data.data.childReplayMoney,
                                childReplayHour: res.data.data.childReplayHour,
                                childReplayGiveHour: res.data.data.childReplayGiveHour,
                                educationPerceiveMoney: res.data.data.educationPerceiveMoney,
                                educationPerceiveHour: res.data.data.educationPerceiveHour,
                                educationPerceiveGiveHour: res.data.data.educationPerceiveGiveHour,
                                fenCaseMoney: res.data.data.fenCaseMoney,
                                fenCaseHour: res.data.data.fenCaseHour,
                                fenCaseGiveHour: res.data.data.fenCaseGiveHour,

                                PaymentTime: res.data.data.chargeCollectionDate,
                                Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                                renewCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],
                                doubtContent: res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : [],

                                affinityBookMoney: res.data.data.affinityBookMoney,
                                affinityBookHour: res.data.data.affinityBookHour,
                                affinityBookGiveHour: res.data.data.affinityBookGiveHour

                          })

                          
                          
                      }
              }


             if(res.data.data.costType === 4 && res.data.data.categoryType === 2){
                      this.isTypeLvess = res.data.data.categoryType === 2 ? 2 : 1

                      this.happyMoney = res.data.data.happyMoney
                      this.happyHour = res.data.data.happyHour
                      this.happyGiveHour = res.data.data.happyGiveHour
                      this.parentAwarenessMoney = res.data.data.parentAwarenessMoney
                      this.parentAwarenessHour = res.data.data.parentAwarenessHour
                      this.parentAwarenessGiveHour = res.data.data.parentAwarenessGiveHour
                      this.familyProblemMoney = res.data.data.familyProblemMoney
                      this.familyProblemHour = res.data.data.familyProblemHour
                      this.familyProblemGiveHour = res.data.data.familyProblemGiveHour
                      this.patriarchReplayMoney = res.data.data.patriarchReplayMoney
                      this.patriarchReplayHour = res.data.data.patriarchReplayHour
                      this.patriarchReplayGiveHour = res.data.data.patriarchReplayGiveHour
                      this.childReplayMoney = res.data.data.childReplayMoney
                      this.childReplayHour = res.data.data.childReplayHour
                      this.childReplayGiveHour = res.data.data.childReplayGiveHour
                      this.educationPerceiveMoney = res.data.data.educationPerceiveMoney
                      this.educationPerceiveHour = res.data.data.educationPerceiveHour
                      this.educationPerceiveGiveHour = res.data.data.educationPerceiveGiveHour
                      this.fenCaseMoney = res.data.data.fenCaseMoney
                      this.fenCaseHour = res.data.data.fenCaseHour
                      this.fenCaseGiveHour = res.data.data.fenCaseGiveHour
                      this.PaymentTime = res.data.data.paymentTime
                      this.Paymentchannel = res.data.data.paymentChannel
                      this.chargeCollectionPicture = res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                      this.doubtContent = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []
                      this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                      this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
                      this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                      this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []

                      this.affinityBookMoney = res.data.data.affinityBookMoney
                      this.affinityBookHour = res.data.data.affinityBookHour
                      this.affinityBookGiveHour = res.data.data.affinityBookGiveHour


               }



              } else {
                  this.$message({  message: res.data.message,   type: "error"  });
              }
          });

        },

        closeEditDialog () {

          this.$emit("newModesCustomerFundingDetailEvent")


          if (this.customerId === 0) {
            this.showEdit = false;
          } else {
            this.showEdit = false;
            this.$emit("resetSuccesType", this.customer);
          }
          this.order.isDiagnosisAllPay = "";
          this.order.diagnosisAllPayMoney = "";
          this.order.diagnosisTime = "";
          this.order.diagnosisPayType = "";
          this.order.isAllPay = "";
          this.order.allPayMoney = "";
          this.order.payTime = "";
          this.order.payType = "";
          this.order.state = "";
          this.order.classHour = ""
          this.order.familyHour = ""
          this.order.renews = [{ renewMoney: "", renewTime: "",  renewType: "" , classHourRenew: "", familyHourRenew: "" }]
          this.order.stages = [{ stagesMoney: "",  stagesDate: "",  payType: "", agingClassHour: "", agingFamilyHour: "" }]
          this.$refs.order.resetFields();
          this.order.startTimeHour = ""
          this.order.onEndTime = ""
          this.order.OffTimeHour = ""
          this.order.offEndTime = ""
        },

        phoneChange() {
      this.order.parentPhoneNumber = this.order.parentPhoneNumber.replace(/[^\d]/g, "");
      if (this.order.parentPhoneNumber.length > 11) {
        this.order.parentPhoneNumber = this.order.parentPhoneNumber.substr(0, 11);
      }
      let reg = /^1[3456789]\d{9}$/;
      if (this.order.parentPhoneNumber.length >= 11 && !reg.test(this.order.parentPhoneNumber)) {
         this.$notify({
          title: '警告',
          message: '请输入正确的手机号码格式',
          type: 'warning'
        });
      }
    },
    qq () {
      console.log(this.order.isRenew);
    },


    handleinput(e){
      console.log(e)
    },
    clickitem (val) {

      if(this.order.isAllPay === val ){
         this.order.isAllPay = ''
      }else{
         this.order.isAllPay = val
      }

      if(val === 1){
          this.order.allPayMoney = ""
          this.order.payTime = ""
          this.order.payAlltype = ""
          this.order.classHour = ""
          this.order.familyHour = ""
      }
      if(val === 2){
        this.order.stages = [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "", // 收款渠道
            agingClassHour: "",
            agingFamilyHour: ""
          }
        ]
      }
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    clearDiagnosis () {
      if (
        this.order.isDiagnosisAllPay == "2" ||
        this.order.isDiagnosisAllPay == "3"
      ) {
        this.order.diagnosisAllPayMoney = "";
        this.order.diagnosisTime = "";
        this.order.diagnosisPayType = "";
      }
    },
    //点击显示钟表
    // dianji() {
    //   this.isshow = !this.isshow;
    // },
    // dianji1() {
    //   this.isshow1 = !this.isshow1;
    // },
    //绑定课程id
    handleChange (val) {
      if (val === this.Lastselected) {
        // 取消选择
        this.isDiagnosisAllPay = '';
      }
      this.Lastselected = this.isDiagnosisAllPay;
    },
    // bingCategory() {
    //   if (this.order.diagnosisAllPayMoney == 2000) {
    //     this.order.courseCategoryId = [25, 26];
    //   }
    // },


    isFull () {
      this.order.stages = [
        {
          stagesMoney: "", // 分期金额
          stagesDate: "", // 分期时间
          payType: "", // 收款渠道
          agingClassHour: "",
          agingFamilyHour: ""
        }
      ];
    },
    isNo () {
      this.order.allPayMoney = "";
      this.order.payTime = "";
      this.order.payAlltype = "";
    },
    //添加输入框
    addInput () {
      this.order.stages.push({
        stagesMoney: "",
        stagesDate: "",
        payType: "", // 收款渠道
        agingClassHour: "",
        agingFamilyHour: ""
      });
    },
    //减少输入框
    removeItem () {
      if (this.order.stages.length > 1) {
        this.order.stages.pop();
      } else {
        this.order.stages.splice(0, this.order.stages.length);
      }
    },

    orderShow (customer) {
      this.showEdit = true;
      this.customer = customer;
      this.order.studentName = customer.customerStudent;
      this.order.type = customer.type;
      this.order.customerInformationId = customer.customerId;
      this.customerId = customer.customerId;
    },

    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.order.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teachers = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    //获取课程类别
    getCategoryList () {
      axios
        .get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },

     getNowTime() {
        var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },

    
    saveEditForm () {


          if (this.checked == true) {
              this.order.onlineStatus = "1";
          } else {
              this.order.onlineStatus = "2";
          }

          if (this.checked1 == true) {
              this.order.offlineStatus = "1";
          } else {
              this.order.offlineStatus = "2";
          }

      // this.$refs["order"].validate(valid => {
      //   if (valid) {
          this.order.onlineTime = [ this.order.onTime,  this.order.startTimeHour,  this.order.onEndTime  ];

          if (this.order.onlineTime.length == 0) {
              this.order.onlineTime = "";
          }

          this.order.offlineTime = [ this.order.offTime,  this.order.OffTimeHour,  this.order.offEndTime  ];

          if (this.order.offlineTime.length == 0) {
              this.order.offlineTime = "";
          }

          // if (this.order.isRenew == 2) {
          //     this.order.renews = null
          // }



          this.order.classHour = this.order.classHour ? Number(this.order.classHour) : 0
          this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : 0


          if(this.order.stages && this.order.stages.length > 1){
             this.order.stages.forEach((itme)=>{
               itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : 0
               itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : 0
             })
          }else{
            //  this.order.stages = []
          }

          if(this.order.renews && this.order.renews.length > 1){
             this.order.renews.forEach((itme)=>{
               itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : 0
               itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : 0
             })
          }else{
            //  this.order.renews = []
          }

          this.order.customerIsallpay = this.order.isAllPay

          // this.order.renews = JSON.stringify(this.order.renews)
          // this.order.stages = JSON.stringify(this.order.stages)

          this.order.auditId = this.ApprovalPeople
          this.order.commitRemark = this.chengRemarks

          // 销售
          this.order.saleId = this.customerAccountName



          let newObj = {   }

          let list = [];
          if(this.newTextareaJson){
           list = [{ remark: this.newTextareaJson, remarkDate: this.getNowTime() }];
           this.textareaJson.push(...list);
          }


          if(this.typeCustomerFunding === '定金'){
              newObj = {

                classType: this.isClassType ? this.isClassType : '',
                diagnosisAllPayMoney: this.paymentAmount ? this.paymentAmount : '',
                diagnosisTime: this.paymentAmountTime ? this.paymentAmountTime : '',
                payType: this.paymentAmountChannel ? this.paymentAmountChannel : '',
                customerHour: this.paymentAmountCourse ? this.paymentAmountCourse : '',
                orderStatus: this.OrderStatus ,
                notCustomerRemark: this.isOrderStatusTextarea ? this.isOrderStatusTextarea : '',


                regionName: this.regionName ? this.regionName : '',
                addressTitleName: this.infoObj.value ? this.infoObj.value : '',
                addressFollow: this.infoObj.address ? this.infoObj.address : '',
                addressInfo: this.detailedAddress ? this.detailedAddress : '',
                addressRemark: this.remarks ? this.remarks : '',
                districtName: this.infoObj.city ? this.infoObj.city : '',
                latitude: this.infoObj.latitude ? this.infoObj.latitude : '',
                precisionLng: this.infoObj.precisionLng ? this.infoObj.precisionLng : '',

                clientNeedRemark:JSON.stringify(this.textareaJson),

                diagnosisCollectionPicture: this.fileAllLists.length > 0 ? JSON.stringify(this.fileAllLists) : JSON.stringify([{ "url": "" , "name": "" }]),
                

              }
          }



          if(this.typeCustomerFunding === '成单'){

              let newStringLsit = this.renewalCollectionList.map((itme)=>{
                 let itmes = {
                    renewMoney: itme.AcademicExpenses || '',
                    classHourRenew: itme.AcademicClasses || '',
                    familyMoney: itme.FamilyEducationExpenses || '',
                    familyHourRenew: itme.FamilyEducationClass || '',
                    readingPartnerMoney: itme.AccompanyingReadingFee || '',
                    readingPartnerHour: itme.AccompanyingReading || '',
                    wayMoney: itme.RemoteRoadRepair || '',
                    renewTime: itme.PaymentTime || '',
                    renewType: itme.Paymentchannel || '',
                    classGiveHour: itme.classGiveHour || '',
                    familyGiveHour: itme.familyGiveHour || '',
                    readingGiveHour: itme.readingGiveHour || '',

                    diagnoseHour: itme.diagnoseHour || '',
                    diagnoseMoney: itme.diagnoseMoney || '',
                    diagnoseGiveHour: itme.diagnoseGiveHour || '',
                    patriarchHour: itme.patriarchHour || '',
                    patriarchGiveHour: itme.patriarchGiveHour || '',
                    patriarchMoney: itme.patriarchMoney || '',
                    studentHour: itme.studentHour || '',
                    studentGiveHour: itme.studentGiveHour || '',
                    studentMoney: itme.studentMoney || '',
                    renewCollectionPicture: itme.renewCollectionPicture && itme.renewCollectionPicture.length > 0 ? JSON.stringify(itme.renewCollectionPicture) : JSON.stringify([{ "url": "" , "name": "" }]),

                 }
                 return itmes
              })



              if(this.setWay === '全款' ){

                  
                    newObj = {
                      classType: this.isClassType ? this.isClassType : '',

                      projectMoney: this.Plan ? this.Plan  : '',
                      allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                      classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                      familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                      familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                      readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                      readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                      
                      wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                      payTime: this.PaymentTime ? this.PaymentTime  : '',
                      payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                      
                      classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                      familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                      readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                      

                      renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',

                      isAllPay: this.isThereACharge ? this.isThereACharge : '',
                      isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                      isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                      auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                      commitRemark: this.chengRemarks ? this.chengRemarks : '',

                      isClose: this.isCustomsDeclaration,
                      closeCause: this.isCustomsDeclarationchengRemarks,




                      projectMoney: this.Plan,
                      diagnoseMoney: this.diagnoseMoney,
                      diagnoseHour: this.diagnoseHour,
                      diagnoseGiveHour: this.diagnoseGiveHour,
                      studentMoney: this.studentMoney,
                      studentHour: this.studentHour,
                      studentGiveHour: this.studentGiveHour,
                      patriarchMoney: this.patriarchMoney,
                      patriarchHour: this.patriarchHour,
                      patriarchGiveHour: this.patriarchGiveHour,
                      chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([{ "url": "" , "name": "" }]),


                      collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                      isProject: this.isProject,
                      contractCost: this.contractAmount,

                    }
                  
              }

              if(this.setWay === '分期' ){


                  newObj = {
                   
                    classType: this.isClassType ? this.isClassType : '',

                    // projectMoney: this.renewalCollectionListWay[0].Plan ? this.renewalCollectionListWay[0].Plan  : '',
                    // allPayMoney: this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : '',
                    // classHour: this.renewalCollectionListWay[0].AcademicClasses ? this.renewalCollectionListWay[0].AcademicClasses  : '',
                    // familyHour: this.renewalCollectionListWay[0].FamilyEducationClass ? this.renewalCollectionListWay[0].FamilyEducationClass  : '',
                    // familyMoney: this.renewalCollectionListWay[0].FamilyEducationExpenses ? this.renewalCollectionListWay[0].FamilyEducationExpenses  : '',
                    // readingPartnerMoney: this.renewalCollectionListWay[0].AccompanyingReadingFee ? this.renewalCollectionListWay[0].AccompanyingReadingFee  : '',
                    // readingPartnerHour: this.renewalCollectionListWay[0].AccompanyingReading ? this.renewalCollectionListWay[0].AccompanyingReading  : '',
                    // wayMoney: this.renewalCollectionListWay[0].RemoteRoadRepair ? this.renewalCollectionListWay[0].RemoteRoadRepair  : '',
                    // payTime: this.renewalCollectionListWay[0].PaymentTime ? this.renewalCollectionListWay[0].PaymentTime  : '',
                    // payAlltype: this.renewalCollectionListWay[0].Paymentchannel ? this.renewalCollectionListWay[0].Paymentchannel  : '',
                    // classGiveHour: this.renewalCollectionListWay[0].classGiveHour ? this.renewalCollectionListWay[0].classGiveHour  : '',
                    // familyGiveHour: this.renewalCollectionListWay[0].familyGiveHour ? this.renewalCollectionListWay[0].familyGiveHour  : '',
                    // readingGiveHour: this.renewalCollectionListWay[0].readingGiveHour ? this.renewalCollectionListWay[0].readingGiveHour  : '',
                    

                    renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',
                    isAllPay: this.isThereACharge ? this.isThereACharge : '',
                    isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                    isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                    auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                    commitRemark: this.chengRemarks ? this.chengRemarks : '',
                    isClose: this.isCustomsDeclaration,
                    closeCause: this.isCustomsDeclarationchengRemarks,


                    // projectMoney: this.renewalCollectionListWay[0].Plan,
                    // diagnoseMoney: this.renewalCollectionListWay[0].diagnoseMoney,
                    // diagnoseHour: this.renewalCollectionListWay[0].diagnoseHour,
                    // diagnoseGiveHour: this.renewalCollectionListWay[0].diagnoseGiveHour,
                    // studentMoney: this.renewalCollectionListWay[0].studentMoney,
                    // studentHour: this.renewalCollectionListWay[0].studentHour,
                    // studentGiveHour: this.renewalCollectionListWay[0].studentGiveHour,
                    // patriarchMoney: this.renewalCollectionListWay[0].patriarchMoney,
                    // patriarchHour: this.renewalCollectionListWay[0].patriarchHour,
                    // patriarchGiveHour: this.renewalCollectionListWay[0].patriarchGiveHour,
                    // chargeCollectionPicture: this.renewalCollectionListWay[0].chargeCollectionPicture.length > 0 ? JSON.stringify(this.renewalCollectionListWay[0].chargeCollectionPicture) : JSON.stringify([{ "url": "" , "name": "" }]),


                    collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                    isProject: this.isProject,
                    contractCost: this.contractAmount,


                    stages: this.renewalCollectionListWay.length > 1 ? this.renewalCollectionListWay.map((itme,index)=>{
                        return {
                              projectMoney: itme.Plan || '',
                              diagnoseMoney: itme.diagnoseMoney || '',
                              customerAllpaymoney: itme.AcademicExpenses || '',
                              familyMoney: itme.FamilyEducationExpenses || '',
                              patriarchMoney: itme.patriarchMoney || '',
                              studentMoney: itme.studentMoney || '',
                              wayMoney: itme.AccompanyingReadingFee || '',
                              readingPartnerMoney: itme.RemoteRoadRepair || '',

                              stagesDate:itme.PaymentTime || '',
                              payType: itme.Paymentchannel || '',
                              stagesPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([{ "url": "" , "name": "" }]),

                              diagnoseHour: itme.diagnoseHour,
                              diagnoseGiveHour: itme.diagnoseGiveHour,
                              studentHour: itme.studentHour,
                              studentGiveHour: itme.studentGiveHour,
                              patriarchHour: itme.patriarchHour,
                              patriarchGiveHour: itme.patriarchGiveHour,

                              allPayMoney: itme.AcademicExpenses ? itme.AcademicExpenses  : '',
                              classHour: itme.AcademicClasses ? itme.AcademicClasses  : '',
                              familyHour: itme.FamilyEducationClass ? itme.FamilyEducationClass  : '',
                              readingPartnerHour: itme.AccompanyingReading ? itme.AccompanyingReading  : '',
                              payTime: itme.PaymentTime ? itme.PaymentTime  : '',
                              payAlltype: itme.Paymentchannel ? itme.Paymentchannel  : '',
                              classGiveHour: v.classGiveHour ? itme.classGiveHour  : '',
                              familyGiveHour: itme.familyGiveHour ? itme.familyGiveHour  : '',
                              readingGiveHour: itme.readingGiveHour ? itme.readingGiveHour  : '',
                              
                            } 
                    }) : [],

                  }

              }
              
          }


          if(this.typeCustomerFunding === '退费'){
              newObj = {
                classType: this.isClassType || '',
                customerReturnType: this.isWantToContinueTheClass || '',

                returnPremium: JSON.stringify({
                    projectMoney: this.Plan || '',
                    returnPremiumPrice: this.AcademicExpenses || '',
                    returnPremiumHour: this.AcademicClasses || '',
                    familyMoney: this.FamilyEducationExpenses || '',
                    familyHourRenew: this.FamilyEducationClass || '',
                    readingPartnerMoney: this.AccompanyingReadingFee || '',
                    readingPartnerHour: this.AccompanyingReading || '',
                    wayMoney: this.RemoteRoadRepair || '',
                    returnPremiumDate: this.PaymentTime || '',
                    returnPremiumPayType: this.Paymentchannel || '',
                }),

                isContinueType: this.isWantToContinueTheClass || '',
                auditId: this.ApprovalPeople || '',
                commitRemark: this.chengRemarks || '',




                classType: this.isClassType ? this.isClassType : '',

                projectMoney: this.Plan ? this.Plan  : '',
                allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                      
                wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                payTime: this.PaymentTime ? this.PaymentTime  : '',
                payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                 
                classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                      

                isAllPay: this.isThereACharge ? this.isThereACharge : '',
                isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                commitRemark: this.chengRemarks ? this.chengRemarks : '',

                isClose: this.isCustomsDeclaration,
                closeCause: this.isCustomsDeclarationchengRemarks,




                projectMoney: this.Plan,
                diagnoseMoney: this.diagnoseMoney,
                diagnoseHour: this.diagnoseHour,
                diagnoseGiveHour: this.diagnoseGiveHour,
                studentMoney: this.studentMoney,
                studentHour: this.studentHour,
                studentGiveHour: this.studentGiveHour,
                patriarchMoney: this.patriarchMoney,
                patriarchHour: this.patriarchHour,
                patriarchGiveHour: this.patriarchGiveHour,
                chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([{ "url": "" , "name": "" }]),


                collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                isProject: this.isProject,
                contractCost: this.contractAmount,

              }
          }


          let keys = Object.keys(newObj)
          keys.forEach((key)=>{
             if (this.order.hasOwnProperty(key)) {
                 delete this.order[key]
             }
          })
          let dateObj = Object.assign(newObj, this.order)
          let isUrView = this.isUrView


          dateObj.customerId = this.customerId

          if(this.isClassType){
             axios.post(`${apiBaseUrl}${isUrView}`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                  if (res.data.code === 200) {

                    this.$message({  message: "编辑成功",  type: "success" });


                    this.$emit("newModesCustomerFundingDetailEvent");

                    this.$emit("refreshOrder");
                    this.showEdit = false;

                    this.infoObj = {}
                    this.remarks = ''
                    this.detailedAddress = ''
                    this.newaddress = ''  
                    this.regionName = ''

                    this.ApprovalPeople = "";
                    this.chengRemarks = "";
                    this.order.auditId = "";
                    this.order.commitRemark = "";

                    this.order.isDiagnosisAllPay = "";
                    this.order.diagnosisAllPayMoney = "";
                    this.order.diagnosisTime = "";
                    this.order.diagnosisPayType = "";
                    this.order.isAllPay = "";
                    this.order.allPayMoney = "";
                    this.order.payTime = "";
                    this.order.payType = "";

                    this.order.startTimeHour = ""
                    this.order.onEndTime = ""
                    this.order.OffTimeHour = ""
                    this.order.offEndTime = ""

                    this.order.classHour = ""
                    this.order.familyHour = ""

                    this.order.renews = [{  renewMoney: "",  renewTime: "",   renewType: ""  , classHourRenew: "", familyHourRenew: "" }]

                    this.order.stages = [ { stagesMoney: "",  stagesDate: "",   payType: "" , agingClassHour: "", agingFamilyHour: "" }]

                    this.$refs.order.resetFields();
                    // this.order.startTime.splice(0, this.order.startTime.length);
                  } else {
                      this.$message({ message: res.data.msg ? res.data.msg : res.data.message, type: "error"  });
                      this.order.classHour = this.order.classHour ? Number(this.order.classHour) : ""
                      this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : ""

                      if(this.order.stages.length > 1){
                        this.order.stages.forEach((itme)=>{
                          itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : ""
                          itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : ""
                        })
                      }

                      if(this.order.renews.length > 1){
                        this.order.renews.forEach((itme)=>{
                          itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : ""
                          itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : ""
                        })
                      }
                  }
                });
          //   }
          // });
              this.$emit("refresh");
          }else{
            this.$message({ message: "请选择学生类型", type: "warning"  });
          }

         
    }


    },



  }



</script>



<style>

.add{
  pointer-events: none;
}

.el-collapse-item__header{
     margin-left: 180px;

}

.init-b{
    text-align: start;
    padding-left: 10px;
    height: 169px;
    overflow-y: auto;
    border: 1px solid #dcd5d5;
    border-radius: 2px;
    padding-top: 10px;
    margin-left: 10px;
}

.inputcolor > .el-input__inner{
  color: red !important;
}

</style>



// WEBPACK FOOTER //
// src/MyApproval/newModesCustomerFundingDetail.vue